var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpLogoDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "2 0 900 340",
    width: "174px",
    height: "40px",
    strokeWidth: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M0 0L0 383L1045 383L1045 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M159 43L159 44L164 44L159 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M164 43L164 44L177 44L164 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M177.667 43.3333L178.333 43.6667L177.667 43.3333M149.667 44.3333L150.333 44.6667L149.667 44.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M151.667 44.3333L152.333 44.6667L151.667 44.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M153 44L153 45L156 45L153 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M316 216C305.581 218.41 295.154 222.285 285 225.667C280.877 227.04 274.981 227.942 271.637 230.843C263.918 237.539 259.995 251.038 252.829 259C231.575 282.617 200.121 297.721 168 296.985C88.9441 295.176 32.329 207.36 74.0147 137C80.2997 126.392 88.4737 116.458 98 108.615C109.043 99.5228 121.346 92.1704 135 87.7454C172.661 75.5406 216.323 84.0419 245 112.015C251.927 118.771 258.35 125.81 263.564 134C266.267 138.244 268.425 145.733 272.498 148.722C283.17 156.553 303.351 158.955 316 163C314.685 146.904 306.807 129.679 298.6 116C263.974 58.2875 191.52 30.5751 127 49.7207C59.0021 69.8984 20.1829 129.986 21.0039 199C21.1982 215.34 26.2043 232.095 32.5787 247C77.7142 352.54 230.785 364.402 293.999 270C304.36 254.528 314.456 234.898 316 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M183 44L183 45L186 45L183 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M186 44L186 45L189 45L186 44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M189.667 44.3333L190.333 44.6667L189.667 44.3333M143 45L144 46L143 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M144 45L145 46L144 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M145.667 45.3333L146.333 45.6667L145.667 45.3333M192.667 45.3333L193.333 45.6667L192.667 45.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M194 45L195 46L194 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M195 45L196 46L195 45M138 46L139 47L138 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M139 46L140 47L139 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M140.667 46.3333L141.333 46.6667L140.667 46.3333M198.667 46.3333L199.333 46.6667L198.667 46.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M200.667 46.3333L201.333 46.6667L200.667 46.3333M133 47L134 48L133 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M134 47L135 48L134 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M135.667 47.3333L136.333 47.6667L135.667 47.3333M203 47L204 48L203 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M204 47L205 48L204 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M205 47L206 48L205 47M129 48L130 49L129 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M130 48L131 49L130 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M131 48L132 49L131 48M207 48L208 49L207 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M208 48L209 49L208 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M209 48L210 49L209 48M126 49L127 50L126 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M127 49L128 50L127 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M211 49L212 50L211 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M212.667 49.3333L213.333 49.6667L212.667 49.3333M123 50L124 51L123 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M124 50L125 51L124 50M214.667 50.3333L215.333 50.6667L214.667 50.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M216 50L217 51L216 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M120 51L121 52L120 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M121 51L122 52L121 51M217 51L218 52L217 51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M218 51L219 52L218 51M117 52L118 53L117 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M118 52L119 53L118 52M220 52L221 53L220 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M221 52L222 53L221 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M114 53L115 54L114 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M115 53L116 54L115 53M223 53L224 54L223 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M224 53L225 54L224 53M112 54L113 55L112 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M113 54L114 55L113 54M226 54L227 55L226 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M227 54L228 55L227 54M109 55L110 56L109 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M110 55L111 56L110 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M228 55L229 56L228 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M229 55L230 56L229 55M107 56L108 57L107 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M108 56L109 57L108 56M230 56L231 57L230 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M231 56L232 57L231 56M105 57L106 58L105 57M233 57L234 58L233 57M103 58L104 59L103 58M235 58L236 59L235 58M101 59L102 60L101 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M237 59L238 60L237 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M238 59L239 60L238 59M99 60L100 61L99 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M239 60L240 61L239 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M240 60L241 61L240 60M97 61L98 62L97 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M98 61L99 62L98 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M241 61L242 62L241 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M95 62L96 63L95 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M96 62L97 63L96 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M243 62L244 63L243 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M93 63L94 64L93 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M94 63L95 64L94 63M244 63L245 64L244 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M245 63L246 64L245 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M92 64L93 65L92 64M246 64L247 65L246 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M247 64L248 65L247 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M90 65L91 66L90 65M248 65L249 66L248 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M89 66L90 67L89 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M250 66L251 67L250 66M398.667 66.3333L399.333 66.6667L398.667 66.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M400 66L401 67L400 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M401 66L401 67L412 67L401 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M412.667 66.3333L413.333 66.6667L412.667 66.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M414.667 66.3333L415.333 66.6667L414.667 66.3333M686 69L706 67C701.095 64.9416 689.304 64.3234 686 69M990.667 66.3333L991.333 66.6667L990.667 66.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M87 67L88 68L87 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M251 67L252 68L251 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M393 67L394 68L393 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M394 67L395 68L394 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M395.667 67.3333L396.333 67.6667L395.667 67.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M341 149C356.873 174.307 409.758 175.514 422.532 146C430.521 127.541 418.112 116.188 402 109.603C395.893 107.108 384.181 103.569 383.951 95.4244C383.499 79.3967 408.682 80.1516 418 84.8102C421.361 86.4907 425.224 90.7452 429 91.0934C432.566 91.4222 440.793 84.6781 440.793 80.9645C440.793 74.5403 427.927 69.9876 423 68.6412C405.988 63.9921 383.134 66.622 371.38 81.0146C356.232 99.5617 369.775 116 388 123.6C394.659 126.377 408.233 131.429 405.282 140.999C400.546 156.356 377.824 154.139 367 148.201C363.352 146.199 359.216 140.357 355 140.167C350.474 139.964 344.507 146.481 341 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M418 67L419 68L418 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M419 67L420 68L419 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M420 67L421 68L420 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M460 67L460 68L543 68L517 67L460 67M556 68L556 69C579.14 63.4908 608.202 68 632 68C625.806 65.4009 616.686 67 610 67C593.49 67 571.816 63.3249 556 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M688 67L689 68L688 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M608 166C613.451 166 622.001 167.612 626.911 164.972C635.577 160.312 638.173 147.56 647.015 143.028C655.458 138.7 672.581 142 682 142C685.306 142 690.812 141.019 693.397 143.603C697.207 147.414 695.999 160.81 696 166L714 166L706 67C701.14 67 694.61 65.8662 690.015 67.6034C680.787 71.0913 671.942 87.5035 665.75 95C646.599 118.187 624.585 140.923 608 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M706 67L706 70L707 70L706 67M762 68L762 69L781 68L762 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M826 67L827 68L826 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M827 67L827 68L910 68L884 67L827 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M923 67L924 68L923 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M924 67L924 68L942 69C938.587 65.0944 928.93 67 924 67M990 67L990 68L1008 68L990 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M86 68L87 69L86 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M253 68L254 69L253 68M382 68L383 69L382 68M390 68L391 69L390 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M391 68L392 69L391 68M422 68L423 69L422 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M423 68L424 69L423 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M424 68L425 69L424 68M459 68L460 69L459 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M455 83L487 84C475.689 109.397 463.268 138.92 457 166C461.451 166 469.702 167.589 473.501 164.972C478.24 161.708 480.106 150.214 482.05 145C487.264 131.015 492.31 116.965 497.576 103C499.603 97.6259 501.034 89.7216 504.818 85.3179C511.053 78.0612 527.673 85.9958 535.775 82.3966C540.067 80.4904 541.617 72.088 543 68L485 68L461.419 68.6034L455 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M543 68L544 69L543 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M521 166L575 166L595.581 164.972L602 151L544 151L554.419 125.603L569 124L605 124L610 109L560 109C561.455 102.858 564.714 87.5128 570.278 84.0278C573.569 81.9665 579.286 83 583 83L612 83C615.769 83 622.242 84.2169 625.501 81.9722C629.157 79.454 630.467 71.9746 632 68L578 68L557.51 69.0278L546.947 95L521 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M687 68L688 69L687 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M707 68L707 79L708 79L707 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M727 166L778 166L797.582 164.972L804 151L751 151L760.308 124L781 68L763.649 69.0278L752.95 95L727 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M826 68L827 69L826 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M822 83L853 83C848.705 111.674 828.238 137.301 824 166C828.281 166 836.725 167.625 840.301 164.972C844.924 161.543 846.816 150.253 848.692 145C853.595 131.271 858.939 117.691 863.947 104C865.989 98.4169 867.41 89.9291 871.559 85.5193C874.846 82.0262 880.853 83.786 885 83.9606C899.001 84.5504 906.698 83.3673 909 68L852 68C845.455 68 834.265 65.8383 828.278 68.6034C824.11 70.5281 822.61 78.9281 822 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M909 68L910 69L909 68M923 68L924 69L923 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M888 166C892.53 166 900.676 167.566 904.581 164.972C915.362 157.81 910.539 133.256 921.419 126.028C924.766 123.805 931.164 125 935 125L969 125L954 166L972 166L1007 68C1002.58 68 994.26 66.3989 990.51 69.0278C980.068 76.3476 983.862 98.8038 974.351 107.397C971.245 110.202 964.857 109 961 109L927 109L941 68L923.702 69.6034L913.192 96L888 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M989 68L990 69L989 68M1007 68L1008 69L1007 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M84 69L85 70L84 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M254 69L255 70L254 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M386 69L387 70L386 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M387 69L388 70L387 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M388 69L389 70L388 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M426 69L427 70L426 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M427 69L428 70L427 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M459 69L460 70L459 69M542 69L543 70L542 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M631 69L632 70L631 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M632 69L633 70L632 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M686 69L687 70L686 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M761.333 69.6667L761.667 70.3333L761.333 69.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M762 69L763 70L762 69M780 69L781 70L780 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M781 69L782 70L781 69M825 69L826 70L825 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M909 69L910 70L909 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M922 69L923 70L922 69M941 69L942 70L941 69M988 69L989 70L988 69M1007.33 69.6667L1007.67 70.3333L1007.33 69.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M83 70L84 71L83 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M256 70L257 71L256 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M385 70L386 71L385 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M428 70L429 71L428 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M429 70L430 71L429 70M542 70L543 71L542 70M555 70L556 71L555 70M631 70L627 83L628 83L631 70M684.667 70.3333L685.333 70.6667L684.667 70.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M706 70L706 74L707 74L706 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M780 70L781 71L780 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M825 70L826 71L825 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M909 70L910 71L909 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M922 70L923 71L922 70M940 70L941 71L940 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M988 70L989 71L988 70M81 71L82 72L81 71M257 71L258 72L257 71M383 71L384 72L383 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M430 71L431 72L430 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M431 71L432 72L431 71M458 71L459 72L458 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M555 71L556 72L555 71M630 71L631 72L630 71M761 71L762 72L761 71M779 71L780 72L779 71M825 71L826 72L825 71M908 71L909 72L908 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M940 71L941 72L940 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M987 71L988 72L987 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M988 71L989 72L988 71M1006 71L1007 72L1006 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M79 72L80 73L79 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M80 72L81 73L80 72M258 72L259 73L258 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M259 72L260 73L259 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M381 72L382 73L381 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M432 72L433 73L432 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M433 72L434 73L433 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M458 72L459 73L458 72M541 72L542 73L541 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M630 72L631 73L630 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M683 72L678 79L683 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M684 72L685 73L684 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M760.333 72.6667L760.667 73.3333L760.333 72.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M779 72L780 73L779 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M780 72L781 73L780 72M908 72L909 73L908 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M921 72L922 73L921 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M1006 72L1007 73L1006 72M78 73L79 74L78 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M260 73L261 74L260 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M379 73L380 74L379 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M434 73L435 74L434 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M457 73L458 74L457 73M541 73L542 74L541 73M554 73L555 74L554 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M683 73L684 74L683 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M779.333 73.6667L779.667 74.3333L779.333 73.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M824 73L825 74L824 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M921 73L922 74L921 73M939 73L940 74L939 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M987 73L988 74L987 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M1005 73L1006 74L1005 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M77 74L78 75L77 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M261 74L262 75L261 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M378 74L379 75L378 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M435 74L436 75L435 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M436 74L437 75L436 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M457 74L458 75L457 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M540 74L541 75L540 74M554 74L555 75L554 74M629 74L630 75L629 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M682 74L683 75L682 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M760 74L761 75L760 74M778 74L779 75L778 74M824 74L825 75L824 74M907 74L908 75L907 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M920 74L921 75L920 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M939 74L940 75L939 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M986 74L984 81L985 81L986 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M987 74L988 75L987 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M1005 74L1006 75L1005 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M76 75L77 76L76 75M262 75L263 76L262 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M263 75L264 76L263 75M376 75L377 76L376 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M377 75L378 76L377 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M437 75L438 76L437 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M457 75L458 76L457 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M540 75L541 76L540 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M553 75L552 77L553 75M759 75L760 76L759 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M778 75L779 76L778 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M823 75L824 76L823 75M907 75L908 76L907 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M920 75L921 76L920 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M939 75L940 76L939 75M1005.33 75.6667L1005.67 76.3333L1005.33 75.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M75 76L76 77L75 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M264 76L265 77L264 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M375 76L376 77L375 76M438 76L439 77L438 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M441 76L442 77L441 76M456 76L457 77L456 76M540 76L541 77L540 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M553 76L554 77L553 76M759 76L760 77L759 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M823 76L824 77L823 76M906 76L907 77L906 76M920 76L921 77L920 76M938 76L939 77L938 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M986 76L987 77L986 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M1004 76L1005 77L1004 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M73 77L74 78L73 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M265 77L266 78L265 77M374 77L375 78L374 77M439 77L440 78L439 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M456 77L457 78L456 77M539 77L540 78L539 77M553 77L554 78L553 77M628 77L629 78L628 77M680 77L681 78L680 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M758.333 77.6667L758.667 78.3333L758.333 77.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M759 77L760 78L759 77M777 77L778 78L777 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M822.333 77.6667L822.667 78.3333L822.333 77.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M906 77L907 78L906 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M919 77L920 78L919 77M938 77L939 78L938 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M1004 77L1005 78L1004 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M72 78L73 79L72 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M266 78L267 79L266 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M373 78L374 79L373 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M440 78L441 79L440 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M455.333 78.6667L455.667 79.3333L455.333 78.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M539 78L540 79L539 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M552 78L553 79L552 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M679 78L680 79L679 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M777 78L778 79L777 78M906 78L907 79L906 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M919 78L920 79L919 78M937 78L938 79L937 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M1004 78L1005 79L1004 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M71 79L72 80L71 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M267 79L268 80L267 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M372 79L373 80L372 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M441 79L442 80L441 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M552 79L553 80L552 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M627 79L628 80L627 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M678 79L679 80L678 79M707 79L707 82L708 82L707 79M758 79L759 80L758 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M776 79L777 80L776 79M822 79L823 80L822 79M905 79L906 80L905 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M937 79L938 80L937 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M985 79L986 80L985 79M1003 79L1004 80L1003 79M70 80L71 81L70 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M269 80L270 81L269 80M371 80L372 81L371 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M442.333 80.6667L442.667 81.3333L442.333 80.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M455 80L456 81L455 80M538 80L539 81L538 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M539 80L540 81L539 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M627 80L628 81L627 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M676 80L672 87L673 87L676 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M677 80L678 81L677 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M758 80L759 81L758 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M776 80L777 81L776 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M905.333 80.6667L905.667 81.3333L905.333 80.6667M918 80L919 81L918 80M1003 80L1004 81L1003 80M68 81L69 82L68 81M270 81L271 82L270 81M370 81L371 82L370 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M401 81L401 82L407 82L401 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M538 81L539 82L538 81M551 81L552 82L551 81M757 81L758 82L757 81M776.333 81.6667L776.667 82.3333L776.333 81.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M821 81L822 82L821 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M918 81L919 82L918 81M936 81L937 82L936 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M984 81L985 82L984 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M67 82L68 83L67 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M161 82L161 83L164 83L161 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M164 82L164 83L174 83L164 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M174 82L174 83L179 83L174 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M271 82L272 83L271 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M396 82L397 83L396 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M397 82L398 83L397 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M398 82L399 83L398 82M409.667 82.3333L410.333 82.6667L409.667 82.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M411 82L412 83L411 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M412 82L413 83L412 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M441 82L442 83L441 82M454 82L455 83L454 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M537 82L504 84L504 85L538 83L537 82M551 82L552 83L551 82M626 82L627 83L626 82M707 82L707 86L708 86L707 82M757 82L758 83L757 82M775 82L776 83L775 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M820 82L821 83L820 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M821 82C825.17 86.7719 840.83 84 847 84L847 83L821 82M904 82L902 83L902 84L904 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M936 82L937 83L936 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M984 82L985 83L984 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M1002 82L1003 83L1002 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M1003 82L1004 83L1003 82M66 83L67 84L66 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M152.667 83.3333L153.333 83.6667L152.667 83.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M154.667 83.3333L155.333 83.6667L154.667 83.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M156.667 83.3333L157.333 83.6667L156.667 83.3333M182.667 83.3333L183.333 83.6667L182.667 83.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M184 83L185 84L184 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M185.667 83.3333L186.333 83.6667L185.667 83.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M272 83L273 84L272 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M369 83L370 84L369 83M393 83L394 84L393 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M394 83L395 84L394 83M414 83L415 84L414 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M415 83L416 84L415 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M440 83L441 84L440 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M454 83L454 84L485 84L454 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M537 83L538 84L537 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M550 83L551 84L550 83M569 83L568 91L565 95C568.485 92.6288 569.204 84.2928 574 87L575 87L576 87L590 84.8302L626 85L611 83L569 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M675 83L676 84L675 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M756 83L755 87L756 87L756 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M775 83L776 84L775 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M849 83L850 84L849 83M851.667 83.3333L852.333 83.6667L851.667 83.3333M873 83L874 84L873 83M876 83L876 84L881 84L876 83M895 83L895 84L898 84L895 83M899 83L900 84L899 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M904 83L905 84L904 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M917 83L918 84L917 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M936 83L937 84L936 83M1002.33 83.6667L1002.67 84.3333L1002.33 83.6667M65 84L66 85L65 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M147 84L148 85L147 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M148 84L149 85L148 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M149 84L150 85L149 84M189 84L190 85L189 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M190 84L191 85L190 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M191.667 84.3333L192.333 84.6667L191.667 84.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M273 84L274 85L273 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M368 84L369 85L368 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M391 84L392 85L391 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M392 84L393 85L392 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M417 84L418 85L417 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M439 84L440 85L439 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M486 84L487 85L486 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M505 84L506 85L505 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M550 84L551 85L550 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M568 84L569 85L568 84M674 84L675 85L674 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M775 84L776 85L775 84M851 84L853 86L853 84L851 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M871 84L872 85L871 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M917 84L918 85L917 84M935 84L936 85L935 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M983 84L984 85L983 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M1001 84L1002 85L1001 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M64 85L65 86L64 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M142 85L143 86L142 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M143 85L144 86L143 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M144 85L145 86L144 85M194 85L195 86L194 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M195 85L196 86L195 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M196 85L197 86L196 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M274 85L275 86L274 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M368 85L369 86L368 85M389 85L390 86L389 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M390 85L391 86L390 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M419 85L420 86L419 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M437 85L438 86L437 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M438 85L439 86L438 85M455 85L456 86L455 85M504 85L505 86L504 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M550 85L551 86L550 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M568 85L569 86L568 85M673 85L674 86L673 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M756 85L757 86L756 85M774 85L775 86L774 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M916 85L917 86L916 85M935 85L936 86L935 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M983 85L984 86L983 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M1001 85L1002 86L1001 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M63 86L64 87L63 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M139 86L140 87L139 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M140 86L141 87L140 86M198 86L199 87L198 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M199 86L200 87L199 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M200 86L201 87L200 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M275 86L276 87L275 86M367 86L368 87L367 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M388 86L389 87L388 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M421 86L422 87L421 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M436 86L437 87L436 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M485 86L486 87L485 86M549 86L550 87L549 86M774 86L775 87L774 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M852 86L853 87L852 86M870 86L871 87L870 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M916 86L917 87L916 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M982 86L983 87L982 86M62 87L63 88L62 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M135 87L136 88L135 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M136 87L137 88L136 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M137 87L138 88L137 87M202 87L203 88L202 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M203 87L204 88L203 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M276 87L277 88L276 87M387 87L388 88L387 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M422 87L423 88L422 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M435 87L436 88L435 87M485 87L486 88L485 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M503 87L504 88L503 87M549 87L550 88L549 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M567 87L568 88L567 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M671 87L672 88L671 87M708 87L709 88L708 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M755 87L756 88L755 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M870 87L871 88L870 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M916 87L917 88L916 87M934 87L935 88L934 87M982 87L983 88L982 87M1000 87L1001 88L1000 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M61 88L62 89L61 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M132 88L133 89L132 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M133 88L134 89L133 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M134 88L135 89L134 88M205 88L206 89L205 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M206 88L207 89L206 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M277 88L278 89L277 88M366 88L367 89L366 88M386 88L387 89L386 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M423 88L424 89L423 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M424 88L425 89L424 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M434 88L435 89L434 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M484 88L485 89L484 88M503 88L504 89L503 88M668 88L669 89L668 88M670 88L668 91L670 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M689 88L688 90L689 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M690.333 88.6667L690.667 89.3333L690.333 88.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M754.333 88.6667L754.667 89.3333L754.333 88.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M755 88L756 89L755 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M773 88L774 89L773 88M851 88L852 89L851 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M869 88L870 89L869 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M915 88L916 89L915 88M934 88L935 89L934 88M1000 88L1001 89L1000 88M60 89L61 90L60 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M130 89L131 90L130 89M208 89L209 90L208 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M209 89L210 90L209 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M278 89L279 90L278 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M366 89L367 90L366 89M385 89L386 90L385 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M425 89L426 90L425 89M433 89L434 90L433 89M484 89L485 90L484 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M502 89L503 90L502 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M548 89L549 90L548 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M670 89L671 90L670 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M689 89L690 97L691 97L689 89M708.333 89.6667L708.667 90.3333L708.333 89.6667M773.333 89.6667L773.667 90.3333L773.333 89.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M851 89L852 90L851 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M869 89L870 90L869 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M915 89L916 90L915 89M933 89L934 90L933 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M981 89L982 90L981 89M59 90L60 91L59 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M127 90L128 91L127 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M128 90L129 91L128 90M210 90L211 91L210 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M211 90L212 91L211 90M279 90L280 91L279 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M365 90L366 91L365 90M385 90L386 91L385 90M426 90L427 91L426 90M432 90L433 91L432 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M484 90L485 91L484 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M502 90L503 91L502 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M548 90L549 91L548 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M566 90L567 91L566 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M567 90L568 91L567 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M669 90L670 91L669 90M754 90L755 91L754 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M772 90L773 91L772 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M850 90L851 91L850 90M869 90L870 91L869 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M933 90L934 91L933 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M981 90L982 91L981 90M999 90L1000 91L999 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M58 91L59 92L58 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M125 91L126 92L125 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M126 91L127 92L126 91M213 91L214 92L213 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M214 91L215 92L214 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M280 91L281 92L280 91M365 91L366 92L365 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M384 91L385 92L384 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M427 91L428 92L427 91M431 91L432 92L431 91M483 91L484 92L483 91M547.333 91.6667L547.667 92.3333L547.333 91.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M668 91L669 92L668 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M688 91L690 94L688 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M708.333 91.6667L708.667 92.3333L708.333 91.6667M772 91L773 92L772 91M850 91L851 92L850 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M868 91L869 92L868 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M914 91L915 92L914 91M933 91L934 92L933 91M980 91L981 92L980 91M999 91L998 95L999 95L999 91M57 92L58 93L57 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M122 92L123 93L122 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M123 92L124 93L123 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M215 92L216 93L215 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M216 92L217 93L216 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M281 92L282 93L281 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M365 92L366 93L365 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M384 92L385 93L384 92M428 92L429 93L428 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M429 92L430 93L429 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M430 92L431 93L430 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M483 92L484 93L483 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M501 92L502 93L501 92M565 92L566 93L565 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M665 92L662 99L663 99L668 92L665 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M686 92L687 93L686 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M753 92L752 94L753 92M772 92L773 93L772 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M868 92L869 93L868 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M914 92L915 93L914 92M932 92L933 93L932 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M980 92L981 93L980 92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M998 92L999 93L998 92M120 93L121 94L120 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M121 93L122 94L121 93M217 93L218 94L217 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M218 93L219 94L218 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M282 93L283 94L282 93M501 93L502 94L501 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M547 93L548 94L547 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M565 93L566 94L565 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M685 93L684 95L685 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M686 93L676 105L662 126L692 127C691.421 118.005 695.137 97.7951 686 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M708 93L708 98L709 98L708 93M753 93L754 94L753 93M771 93L772 94L771 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M849 93L850 94L849 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M932 93L933 94L932 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M980 93L981 94L980 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M998 93L999 94L998 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M56 94L57 95L56 94M118 94L119 95L118 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M119 94L120 95L119 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M220 94L221 95L220 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M283 94L284 95L283 94M364 94L365 95L364 94M387 94L388 95L387 94M482 94L483 95L482 94M546 94L547 95L546 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M666 94L667 95L666 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M685.667 94.3333L686.333 94.6667L685.667 94.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M771 94L772 95L771 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M849 94L850 95L849 94M867 94L868 95L867 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M913 94L914 95L913 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M979 94L980 95L979 94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M55 95L56 96L55 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M117 95L118 96L117 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M221 95L222 96L221 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M222 95L223 96L222 95M283 95L284 96L283 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M364.333 95.6667L364.667 96.3333L364.333 95.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M383 95L384 96L383 95M482 95L483 96L482 95M500 95L501 96L500 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M546 95L547 96L546 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M564 95L565 96L564 95M665 95L666 96L665 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M684 95L685 96L684 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M752 95L753 96L752 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M771 95L772 96L771 95M867.333 95.6667L867.667 96.3333L867.333 95.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M913 95L914 96L913 95M931 95L932 96L931 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M979 95L980 96L979 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M997 95L998 96L997 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M54 96L55 97L54 96M115 96L116 97L115 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M223 96L224 97L223 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M224 96L225 97L224 96M284 96L285 97L284 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M500 96L501 97L500 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M546 96L547 97L546 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M564 96L564 98L566 96L564 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M664 96L665 97L664 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M683 96L680 101L683 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M691 96L691 101L692 101L691 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M709 96L709 100L710 100L709 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M752 96L753 97L752 96M770 96L771 97L770 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M848 96L849 97L848 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M866 96L867 97L866 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M912 96L913 97L912 96M931 96L932 97L931 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M979 96L980 97L979 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M997 96L998 97L997 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M53 97L54 98L53 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M113 97L114 98L113 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M114 97L115 98L114 97M225 97L226 98L225 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M285 97L286 98L285 97M364 97L364 101L365 101L364 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M481 97L482 98L481 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M499 97L500 98L499 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M545 97L546 98L545 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M663 97L664 98L663 97M682 97L683 98L682 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M751 97L752 98L751 97M770.333 97.6667L770.667 98.3333L770.333 97.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M848 97L849 98L848 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M866 97L867 98L866 97M912 97L913 98L912 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M978 97L979 98L978 97M997 97L996 101L997 101L997 97M52 98L53 99L52 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M111 98L112 99L111 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M112 98L113 99L112 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M227 98L228 99L227 98M286 98L287 99L286 98M384 98L385 99L384 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M481 98L482 99L481 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M499 98L500 99L499 98M545 98L546 99L545 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M563 98L564 99L563 98M681 98L682 99L681 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M751 98L752 99L751 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M769 98L770 99L769 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M866 98L867 99L866 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M930 98L931 99L930 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M978 98L979 99L978 98M996 98L997 99L996 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M110 99L111 100L110 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M228 99L229 100L228 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M229 99L230 100L229 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M287 99L288 100L287 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M384 99L385 100L384 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M480 99L481 100L480 99M499 99L500 100L499 99M563 99L563 104L563 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M680 99L681 100L680 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M684 99L685 100L684 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M769 99L770 100L769 99M847 99L848 100L847 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M865 99L866 100L865 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M911 99L912 100L911 99M930 99L931 100L930 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M51 100L52 101L51 100M108 100L109 101L108 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M230 100L231 101L230 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M288 100L289 101L288 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M385 100L386 101L385 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M480 100L481 101L480 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M498 100L499 101L498 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M544 100L545 101L544 100M660 100L650 113L660 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M661 100L662 101L661 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M750 100L749 102L750 100M769 100L770 101L769 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M847 100L848 101L847 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M865 100L866 101L865 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M911 100L912 101L911 100M929 100L930 101L929 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M977 100L978 101L977 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M50 101L51 102L50 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M107 101L108 102L107 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M231 101L232 102L231 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M232 101L233 102L232 101M288 101L289 102L288 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M364.333 101.667L364.667 102.333L364.333 101.667M386 101L387 102L386 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M480 101L481 102L480 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M498 101L499 102L498 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M544 101L545 102L544 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M562 101L563 102L562 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M660 101L661 102L660 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M679 101L677 105L679 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M691 101L691 104L692 104L691 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M709.333 101.667L709.667 102.333L709.333 101.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M750 101L751 102L750 101M768 101L769 102L768 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M846 101L847 102L846 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M929 101L930 102L929 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M977 101L978 102L977 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M995 101L996 102L995 101M49 102L50 103L49 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M105 102L106 103L105 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M106 102L107 103L106 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M233 102L234 103L233 102M289 102L290 103L289 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M387 102L388 103L387 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M479 102L480 103L479 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M659 102L660 103L659 102M678 102L679 103L678 102M768 102L769 103L768 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M846 102L847 103L846 102M864 102L865 103L864 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M910 102L911 103L910 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M976 102L977 103L976 102M995 102L996 103L995 102M48 103L49 104L48 103M104 103L105 104L104 103M234 103L235 104L234 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M235 103L236 104L235 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M290 103L291 104L290 103M364 103L365 104L364 103M389 103L390 104L389 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M479 103L480 104L479 103M497 103L498 104L497 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M543 103L544 104L543 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M561 103L562 104L561 103M677 103L678 104L677 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M709.333 103.667L709.667 104.333L709.333 103.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M749 103L750 104L749 103M845.333 103.667L845.667 104.333L845.333 103.667M864 103L865 104L864 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M910 103L911 104L910 103M928 103L929 104L928 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M976 103L977 104L976 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M994 103L995 104L994 103M48 104L49 105L48 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M103 104L104 105L103 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M236 104L237 105L236 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M291 104L292 105L291 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M390 104L391 105L390 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M391 104L392 105L391 104M497.333 104.667L497.667 105.333L497.333 104.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M543 104L544 105L543 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M561 104L562 105L561 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M676 104L677 105L676 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M691.333 104.667L691.667 105.333L691.333 104.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M749 104L750 105L749 104M767 104L768 105L767 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M909 104L910 105L909 104M928.333 104.667L928.667 105.333L928.333 104.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M976 104L977 105L976 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M994 104L995 105L994 104M47 105L48 106L47 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M101 105L102 106L101 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M237 105L238 106L237 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M291 105L292 106L291 105M365 105L366 106L365 105M392 105L393 106L392 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M393 105L394 106L393 105M402 105L403 106L402 105M478 105L479 106L478 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M496 105L497 106L496 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M542 105L543 106L542 105M561.667 105.333L562.333 105.667L561.667 105.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M657 105L658 106L657 105M709 105L709 109L710 109L709 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M748 105L749 106L748 105M767.333 105.667L767.667 106.333L767.333 105.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M845 105L846 106L845 105M863 105L864 106L863 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M909 105L910 106L909 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M975 105L976 106L975 105M46 106L47 107L46 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M100 106L101 107L100 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M238 106L239 107L238 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M292 106L293 107L292 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M365 106L366 107L365 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M394 106L395 107L394 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M395 106L396 107L395 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M478 106L479 107L478 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M496 106L497 107L496 106M542 106L543 107L542 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M560 106L561 107L560 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M560 109L609 108L609 113L612 108L609 108L610 106L574 107.116L560 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M656 106L657 107L656 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M674 109L677 106L674 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M748 106L749 107L748 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M844 106L845 107L844 106M863 106L864 107L863 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M909 106L910 107L909 106M927 106L928 107L927 106M975 106L976 107L975 106M993 106L994 107L993 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M994 106L995 107L994 106M99 107L100 108L99 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M240 107L241 108L240 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M293 107L294 108L293 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M396 107L397 108L396 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M397 107L398 108L397 107M477 107L478 108L477 107M496 107L497 108L496 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M655 107L656 108L655 107M674 107L675 108L674 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M691 107L691 111L692 111L691 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M748 107L749 108L748 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M766 107L767 108L766 107M844 107L845 108L844 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M862 107L863 108L862 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M908 107L909 108L908 107M927 107L928 108L927 107M993.333 107.667L993.667 108.333L993.333 107.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M45 108L46 109L45 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M98 108L99 109L98 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M241 108L242 109L241 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M366 108L367 109L366 108M399 108L400 109L399 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M400 108L401 109L400 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M477 108L478 109L477 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M495 108L496 109L495 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M541 108L542 109L541 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M562 108L563 109L562 108M608 108L609 109L608 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M654 108L655 109L654 108M673 108L674 109L673 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M710 108L710 115L711 115L710 108M747 108L746 112L747 112L747 108M766 108L767 109L766 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M844 108L845 109L844 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M862 108L863 109L862 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M908 108L909 109L908 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M927 108L927 109L975 109C962.586 103.791 940.526 108 927 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M44 109L45 110L44 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M96 109L97 110L96 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M242 109L243 110L242 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M294 109L295 110L294 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M364 109L365 110L364 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M367 109L368 110L367 109M401 109L402 110L401 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M402 109L403 110L402 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M477 109L478 110L477 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M495 109L496 110L495 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M541 109L542 110L541 109M672 109L673 110L672 109M747 109L748 110L747 109M765 109L766 110L765 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M843 109L844 110L843 109M862 109L863 110L862 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M992 109L993 110L992 109M95 110L96 111L95 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M243 110L244 111L243 110M295 110L296 111L295 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M367 110L368 111L367 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M404 110L405 111L404 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M405 110L406 111L405 110M476 110L477 111L476 110M495 110L496 111L495 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M671 110L672 111L671 110M692 110L692 115L693 115L692 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M765 110L766 111L765 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M843 110L844 111L843 110M861 110L862 111L861 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M907 110L908 111L907 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M992 110L993 111L992 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M43 111L44 112L43 111M94 111L95 112L94 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M244 111L245 112L244 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M368 111L369 112L368 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M406 111L407 112L406 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M407 111L408 112L407 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M476 111L477 112L476 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M494 111L495 112L494 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M540 111L541 112L540 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M609 111L610 112L609 111M652 111L653 112L652 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M671 111L669 115L671 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M861 111L862 112L861 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M907 111L908 112L907 111M991 111L992 112L991 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M42 112L43 113L42 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M93 112L94 113L93 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M245 112L246 113L245 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M296 112L297 113L296 112M369 112L370 113L369 112M408 112L409 113L408 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M409 112L410 113L409 112M494 112L495 113L494 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M540 112L541 113L540 112M651 112L652 113L651 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M670 112L671 113L670 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M691 112L691 115L692 115L691 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M746 112L747 113L746 112M764 112L765 113L764 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M842 112L843 113L842 112M906 112L907 113L906 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M991 112L992 113L991 112M92 113L93 114L92 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M246 113L247 114L246 113M297 113L298 114L297 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M370 113L371 114L370 113M410 113L411 114L410 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M411 113L412 114L411 113M475 113L476 114L475 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M608 113L609 114L608 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M650 113L651 114L650 113M669 113L670 114L669 113M764 113L765 114L764 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M842 113L843 114L842 113M860 113L861 114L860 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M906 113L907 114L906 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M991.333 113.667L991.667 114.333L991.333 113.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M41 114L42 115L41 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M91 114L92 115L91 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M247 114L248 115L247 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M297 114L298 115L297 114M371 114L372 115L371 114M412 114L413 115L412 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M413 114L414 115L413 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M475 114L476 115L475 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M493 114L494 115L493 114M539 114L540 115L539 114M608 114L609 115L608 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M609 114L610 115L609 114M648 114L645 117L645 118L650 114L648 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M668 114L669 115L668 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M745 114L746 115L745 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M764 114L765 115L764 114M860 114L861 115L860 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M906 114L907 115L906 114M990 114L991 115L990 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M40 115L41 116L40 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M90 115L91 116L90 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M248 115L249 116L248 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M298 115L299 116L298 115M372 115L373 116L372 115M414 115L415 116L414 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M493 115L494 116L493 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M539 115L540 116L539 115M667 115L668 116L667 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M692.333 115.667L692.667 116.333L692.333 115.667M710.333 115.667L710.667 116.333L710.333 115.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M745 115L746 116L745 115M763 115L764 116L763 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M841 115L842 116L841 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M905 115L906 116L905 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M990 115L991 116L990 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M40 116L41 117L40 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M89 116L90 117L89 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M249 116L250 117L249 116M373 116L374 117L373 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M374 116L375 117L374 116M415 116L416 117L415 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M416 116L417 117L416 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M474 116L475 117L474 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M492 116L493 117L492 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M538 116L539 117L538 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M607 116L608 117L607 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M608 116L605 125L606 125L608 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M648 116L649 117L648 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M667 116L664 121L667 116M744 116L745 117L744 116M763.333 116.667L763.667 117.333L763.333 116.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M841 116L842 117L841 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M859 116L860 117L859 116M905 116L906 117L905 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M990 116L989 120L990 120L990 116M39 117L40 118L39 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M88 117L89 118L88 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M250 117L251 118L250 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M299 117L300 118L299 117M375 117L376 118L375 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M417 117L418 118L417 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M474 117L475 118L474 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M492 117L493 118L492 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M538 117L539 118L538 117M647 117L648 118L647 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M692 117L692 127L693 127L692 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M710 117L710 121L711 121L710 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M744 117L745 118L744 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M762 117L763 118L762 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M840 117L841 118L840 117M859 117L860 118L859 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M989 117L990 118L989 117M39 118L40 119L39 118M87 118L88 119L87 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M251 118L252 119L251 118M300 118L301 119L300 118M376 118L377 119L376 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M377 118L378 119L377 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M418 118L419 119L418 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M473 118L474 119L473 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M646 118L647 119L646 118M665 118L666 119L665 118M762 118L763 119L762 118M840 118L841 119L840 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M858 118L859 119L858 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M904 118L905 119L904 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M38 119L39 120L38 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M86 119L87 120L86 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M252 119L253 120L252 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M300 119L301 120L300 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M378 119L379 120L378 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M379 119L380 120L379 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M419 119L420 120L419 119M473 119L474 120L473 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M491 119L492 120L491 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M537 119L538 120L537 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M606 119L607 120L606 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M644.333 119.667L644.667 120.333L644.333 119.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M645 119L646 120L645 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M664 119L665 120L664 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M743 119L744 120L743 119M762 119L763 120L762 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M858 119L859 120L858 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M904 119L905 120L904 119M988 119L989 120L988 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M253 120L254 121L253 120M301 120L302 121L301 120M380 120L381 121L380 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M381 120L382 121L381 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M420 120L421 121L420 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M491 120L492 121L491 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M537 120L538 121L537 120M663 120L664 121L663 120M743 120L744 121L743 120M761 120L762 121L761 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M839 120L840 121L839 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M988 120L989 121L988 120M37 121L38 122L37 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M85 121L86 122L85 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M254 121L255 122L254 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M382 121L383 122L382 121M421 121L422 122L421 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M472 121L473 122L472 121M536 121L537 122L536 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M605 121L606 122L605 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M643 121L640 123L640 124L643 121M711 121L711 124L712 124L711 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M761 121L762 122L761 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M839 121L840 122L839 121M857 121L858 122L857 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M903 121L904 122L903 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M988.333 121.667L988.667 122.333L988.333 121.667M36 122L37 123L36 122M84 122L85 123L84 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M255 122L256 123L255 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M302 122L303 123L302 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M384 122L385 123L384 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M385 122L386 123L385 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M422 122L423 123L422 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M472 122L473 123L472 122M490 122L491 123L490 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M536 122L537 123L536 122M605 122L606 123L605 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M643 122L644 123L643 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M662 122L663 123L662 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M742 122L743 123L742 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M761 122L762 123L761 122M857 122L858 123L857 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M903 122L904 123L903 122M987 122L988 123L987 122M36 123L37 124L36 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M83 123L84 124L83 123M255 123L256 124L255 123M386 123L387 124L386 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M387 123L388 124L387 123M422 123L423 124L422 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M490 123L491 124L490 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M536 123L537 124L536 123M642 123L643 124L642 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M661 123L662 124L661 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M693 123L693 127L694 127L693 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M741.333 123.667L741.667 124.333L741.333 123.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M742 123L743 124L742 123M760 123L761 124L760 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M838 123L839 124L838 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M902 123L903 124L902 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M987 123L988 124L987 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M35 124L36 125L35 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M82 124L83 125L82 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M256 124L257 125L256 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M303 124L304 125L303 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M388 124L389 125L388 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M389 124L390 125L389 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M390 124L391 125L390 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M423 124L424 125L423 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M471 124L472 125L471 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M535 124L536 125L535 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M554 124L555 125L554 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M555 124L556 125L555 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M556 124L556 125L601 125C589.299 120.09 568.742 124 556 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M601 124L602 125L601 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M602 124L602 125L605 125L602 124M641 124L642 125L641 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M660 124L659 126L660 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M661 124L659 127L688 127L688 126C679.754 126 668.372 128.1 661 124M760 124L761 125L760 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M838 124L839 125L838 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M856 124L857 125L856 124M902 124L903 125L902 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M987 124L988 125L987 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M35 125L36 126L35 125M81 125L82 126L81 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M257 125L258 126L257 125M391 125L392 126L391 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M392 125L393 126L392 125M423 125L424 126L423 125M471 125L472 126L471 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M489 125L490 126L489 125M535 125L536 126L535 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M553 125L554 126L553 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M554 125L555 126L554 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M553 126L553 127L558 126L553 126M559 125L559 126L592 126L559 125M594 125L594 126L600 126L594 125M601.667 125.333L602.333 125.667L601.667 125.333M639.333 125.667L639.667 126.333L639.333 125.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M640 125L641 126L640 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M711.333 125.667L711.667 126.333L711.333 125.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M741 125L742 126L741 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M856 125L857 126L856 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M902 125L903 126L902 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M920 125L921 126L920 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M921 125L922 126L921 125M926 125L927 126L926 125M961 125L962 126L961 125M967.333 125.667L967.667 126.333L967.333 125.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M968 125L969 126L968 125M986 125L987 126L986 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M34 126L35 127L34 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M104 126L105 127L104 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M105.333 126.667L105.667 127.333L105.333 126.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M106.667 126.333L107.333 126.667L106.667 126.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M258 126L259 127L258 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M304 126L305 127L304 126M394 126L395 127L394 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M424 126L425 127L424 126M470 126L471 127L470 126M489 126L490 127L489 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M535 126L536 127L535 126M741 126L742 127L741 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M759 126L760 127L759 126M837 126L838 127L837 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M855 126L856 127L855 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M901 126L902 127L901 126M920 126L921 127L920 126M986.333 126.667L986.667 127.333L986.333 126.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M34 127L35 128L34 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M80 127L81 128L80 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M106 127L122.35 149L155 189L155 190L135 214L105 252L170 234.424L332 190L332 189L106 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M108.667 127.333L109.333 127.667L108.667 127.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M110 127L111 128L110 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M304 127L305 128L304 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M396 127L397 128L396 127M424 127L425 128L424 127M470 127L471 128L470 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M488 127L489 128L488 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M534 127L535 128L534 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M552 127L553 128L552 127M659 127L659 128L691 128L659 127M692 127L693 128L692 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M711.333 127.667L711.667 128.333L711.333 127.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M740 127L741 128L740 127M759 127L760 128L759 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M837 127L838 128L837 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M855 127L856 128L855 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M901 127L902 128L901 127M919 127L920 128L919 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M967 127L968 128L967 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M79 128L80 129L79 128M112 128L113 129L112 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M113 128L114 129L113 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M114 128L115 129L114 128M259 128L260 129L259 128M305 128L306 129L305 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M398 128L399 129L398 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M470 128L471 129L470 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M488.333 128.667L488.667 129.333L488.333 128.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M534 128L535 129L534 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M552 128L553 129L552 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M553 128L554 129L553 128M637 128L635 132L636 132L637 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M638 128L639 129L638 128M740 128L741 129L740 128M758 128L759 129L758 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M836 128L837 129L836 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M919 128L920 129L919 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M967 128L968 129L967 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M985 128L986 129L985 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M33 129L34 130L33 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M106 129L107 130L106 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M116 129L117 130L116 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M117 129L118 130L117 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M260 129L261 130L260 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M305 129L306 130L305 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M399 129L400 130L399 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M400 129L401 130L400 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M425 129L425 132L426 132L425 129M469 129L470 130L469 129M552 129L553 130L552 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M637 129L638 130L637 129M711 129L711 133L712 133L711 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M739 129L738 132L739 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M758 129L759 130L758 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M836 129L837 130L836 129M854 129L855 130L854 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M900 129L901 130L900 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M966 129L967 130L966 129M985.333 129.667L985.667 130.333L985.333 129.667M78 130L79 131L78 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M107 130L108 131L107 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M119 130L120 131L119 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M120 130L121 131L120 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M121 130L122 131L121 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M261 130L262 131L261 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M306 130L307 131L306 130M401 130L402 131L401 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M469 130L470 131L469 130M487 130L488 131L487 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M533 130L534 131L533 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M551 130L552 131L551 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M636 130L637 131L636 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M854.333 130.667L854.667 131.333L854.333 130.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M900 130L901 131L900 130M918 130L919 131L918 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M966 130L967 131L966 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M984 130L985 131L984 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M32 131L33 132L32 131M77 131L78 132L77 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M108 131L109 132L108 131M123 131L124 132L123 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M124 131L125 132L124 131M261 131L262 132L261 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M306 131L307 132L306 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M402 131L403 132L402 131M487 131L488 132L487 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M533 131L534 132L533 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M551 131L550 135L553 131L551 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M739 131L740 132L739 131M757 131L758 132L757 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M835 131L836 132L835 131M918 131L919 132L918 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M966 131L967 132L966 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M984 131L985 132L984 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M32 132L33 133L32 132M76 132L77 133L76 132M109 132L110 133L109 132M126.667 132.333L127.333 132.667L126.667 132.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M128 132L129 133L128 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M262 132L263 133L262 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M307 132L308 133L307 132M403 132L404 133L403 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M425 132L426 133L425 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M468 132L469 133L468 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M486 132L487 133L486 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M532 132L533 133L532 132M634 132L635 133L634 132M757.333 132.667L757.667 133.333L757.333 132.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M835 132L836 133L835 132M853 132L854 133L853 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M899 132L900 133L899 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M965 132L966 133L965 132M984 132L985 133L984 132M31 133L32 134L31 133M76 133L77 134L76 133M109 133L110 134L109 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M130 133L131 134L130 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M131 133L132 134L131 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M132 133L133 134L132 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M263 133L264 134L263 133M307 133L308 134L307 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M404 133L405 134L404 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M425 133L426 134L425 133M468 133L469 134L468 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M486 133L487 134L486 133M532 133L533 134L532 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M550 133L551 134L550 133M634 133L635 134L634 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M738 133L739 134L738 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M853 133L854 134L853 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M899 133L900 134L899 133M917 133L918 134L917 133M965 133L966 134L965 133M983 133L984 134L983 133M31 134L32 135L31 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M75 134L76 135L75 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M110 134L111 135L110 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M134 134L135 135L134 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M135 134L136 135L135 134M263 134L264 135L263 134M308 134L309 135L308 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M425 134L425 137L426 137L425 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M467 134L468 135L467 134M486 134L487 135L486 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M532 134L533 135L532 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M632 134L623 146L632 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M633 134L634 135L633 134M738 134L739 135L738 134M756 134L757 135L756 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M834 134L835 135L834 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M852 134L853 135L852 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M898 134L899 135L898 134M917 134L918 135L917 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M983 134L984 135L983 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M30 135L31 136L30 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M111 135L112 136L111 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M137 135L138 136L137 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M138 135L139 136L138 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M139 135L140 136L139 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M264 135L265 136L264 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M308 135L309 136L308 135M405 135L406 136L405 135M467 135L468 136L467 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M485 135L486 136L485 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M531 135L532 136L531 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M632 135L633 136L632 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M712 135L712 139L713 139L712 135M737 135L738 136L737 135M756 135L757 136L756 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M834 135L835 136L834 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M852 135L853 136L852 135M898 135L899 136L898 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M916 135L917 136L916 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M964 135L965 136L964 135M983 135L984 136L983 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M30 136L31 137L30 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M74 136L75 137L74 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M112 136L113 137L112 136M141 136L142 137L141 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M142 136L143 137L142 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M143 136L144 137L143 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M308 136L309 137L308 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M405 136L406 137L405 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M467 136L468 137L467 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M485 136L486 137L485 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M531 136L532 137L531 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M549 136L550 137L549 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M550 136L551 137L550 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M631 136L632 137L631 136M737 136L738 137L737 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M755 136L756 137L755 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M833 136L834 137L833 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M916 136L917 137L916 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M964 136L965 137L964 136M982 136L983 137L982 136M73 137L74 138L73 137M113 137L114 138L113 137M145 137L146 138L145 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M146 137L147 138L146 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M265 137L266 138L265 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M309 137L310 138L309 137M425.333 137.667L425.667 138.333L425.333 137.667M466 137L467 138L466 137M549 137L549 142L549 137M556 137L557 138L556 137M736 137L735 142L736 142L736 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M737 137L738 138L737 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M755 137L756 138L755 137M833 137L834 138L833 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M851 137L852 138L851 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M897 137L898 138L897 137M916 137L917 138L916 137M982 137L983 138L982 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M29 138L30 139L29 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M73 138L74 139L73 138M113 138L114 139L113 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M148 138L149 139L148 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M149 138L150 139L149 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M150 138L151 139L150 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M266 138L267 139L266 138M309 138L310 139L309 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M355 138L356 139L355 138M402 138L403 139L402 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M466 138L467 139L466 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M484 138L485 139L484 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M530 138L531 139L530 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M548 138L549 139L548 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M549 138L550 139L549 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M755 138L756 139L755 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M851 138L852 139L851 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M897 138L898 139L897 138M915 138L916 139L915 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M963 138L964 139L963 138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M29 139L30 140L29 139M72 139L73 140L72 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M114 139L115 140L114 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M152 139L153 140L152 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M153 139L154 140L153 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M266 139L267 140L266 139M353 139L354 140L353 139M356 139L357 140L356 139M405 139L406 140L405 139M484 139L485 140L484 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M530 139L531 140L530 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M548 139L549 140L548 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M629 139L630 140L629 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M712.333 139.667L712.667 140.333L712.333 139.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M736 139L737 140L736 139M754 139L755 140L754 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M832 139L833 140L832 139M851 139L852 140L851 139M896 139L897 140L896 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M915 139L916 140L915 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M963 139L964 140L963 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M981 139L982 140L981 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M28 140L29 141L28 140M72 140L73 141L72 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M115 140L116 141L115 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M155 140L156 141L155 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M156 140L157 141L156 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M157 140L158 141L157 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M267 140L268 141L267 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M310 140L311 141L310 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M352 140L353 141L352 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M357 140L358 141L357 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M405 140L406 141L405 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M424 140L425 141L424 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M465 140L466 141L465 140M529 140L530 141L529 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M628 140L629 141L628 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M754 140L755 141L754 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M832 140L833 141L832 140M850 140L851 141L850 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M896 140L897 141L896 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M915 140L916 141L915 140M962 140L963 141L962 140M981 140L982 141L981 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M28 141L29 142L28 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M71 141L72 142L71 141M116 141L117 142L116 141M159 141L160 142L159 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M160 141L161 142L160 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M161 141L162 142L161 141M267 141L268 142L267 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M310 141L311 142L310 141M351 141L352 142L351 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M358 141L359 142L358 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M405 141L406 142L405 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M424 141L425 142L424 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M465 141L466 142L465 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M483 141L484 142L483 141M529 141L530 142L529 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M547 141L548 142L547 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M627 141L628 142L627 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M712 141L712 145L713 145L712 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M850 141L851 142L850 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M896 141L897 142L896 141M914 141L915 142L914 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M962 141L963 142L962 141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M980 141L981 142L980 141M28 142L29 143L28 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M71 142L72 143L71 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M117 142L118 143L117 142M163 142L164 143L163 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M164.667 142.333L165.333 142.667L164.667 142.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M268 142L269 143L268 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M311 142L312 143L311 142M349 142L350 143L349 142M359 142L360 143L359 142M404 142L405 143L404 142M424 142L425 143L424 142M483 142L484 143L483 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M529 142L530 143L529 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M547 142L548 143L547 142M552 142L556 145L556 144L552 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M646 142L646 143L681 143C685.572 143 691.26 141.773 694 146C695.21 140.614 686.407 142 683 142L646 142M735 142L736 143L735 142M753 142L754 143L753 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M831 142L832 143L831 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M849 142L850 143L849 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M914.333 142.667L914.667 143.333L914.333 142.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M980 142L981 143L980 142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M70 143L71 144L70 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M117 143L118 144L117 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M166 143L167 144L166 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M167 143L168 144L167 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M168 143L169 144L168 143M268 143L269 144L268 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M311 143L312 144L311 143M348 143L349 144L348 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M360 143L361 144L360 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M404 143L405 144L404 143M423 143L424 144L423 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M464 143L465 144L464 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M482 143L483 144L482 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M528 143L529 144L528 143M641 150C653.154 140.861 678.926 141.411 694 145C691.03 141.601 684.241 143 680 143C668.933 143 646.329 138.184 641 150M753 143L754 144L753 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M831 143L832 144L831 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M849 143L850 144L849 143M895 143L896 144L895 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M913 143L914 144L913 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M961 143L962 144L961 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M27 144L28 145L27 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M70 144L71 145L70 144M118 144L119 145L118 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M170 144L171 145L170 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M171 144L172 145L171 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M172 144L173 145L172 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M269 144L270 145L269 144M347 144L348 145L347 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M361 144L362 145L361 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M403 144L404 145L403 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M423 144L424 145L423 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M464 144L465 145L464 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M482 144L483 145L482 144M528 144L529 145L528 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M546 144L547 145L546 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M547 144L545 151L603 151L603 150C589.015 146.217 560.861 145.903 547 150L547 144M549 144L550 145L549 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M644 144L645 145L644 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M713 144L713 150L714 150L713 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M734 144L735 145L734 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M752 144L753 145L752 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M830 144L831 145L830 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M895 144L896 145L895 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M913 144L914 145L913 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M961 144L962 145L961 144M979 144L980 145L979 144M27 145L28 146L27 145M69 145L70 146L69 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M119 145L120 146L119 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M174 145L175 146L174 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M175 145L176 146L175 145M269 145L270 146L269 145M312 145L313 146L312 145M345 145L346 146L345 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M362 145L363 146L362 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M402 145L401 147L402 145M423 145L424 146L423 145M482 145L483 146L482 145M619 145L620 146L619 145M621 145L622 146L621 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M624 145L625 146L624 145M643 145L644 146L643 145M734 145L735 146L734 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M752 145L753 146L752 145M830 145L831 146L830 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M848 145L849 146L848 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M894 145L895 146L894 145M913 145L914 146L913 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M979 145L980 146L979 145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M69 146L70 147L69 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M120 146L121 147L120 146M177 146L178 147L177 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M178 146L179 147L178 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M179 146L180 147L179 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M270 146L271 147L270 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M312 146L313 147L312 146M344 146L345 147L344 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M363 146L364 147L363 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M364 146L365 147L364 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M402 146L403 147L402 146M422 146L423 147L422 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M463 146L464 147L463 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M481 146L482 147L481 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M527 146L528 147L527 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M546 146L547 147L546 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M623 146L624 147L623 146M642 146L643 147L642 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M694 146L694 149L695 149L694 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M733 146L734 147L733 146M752.333 146.667L752.667 147.333L752.333 146.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M830 146L831 147L830 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M848 146L849 147L848 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M894 146L895 147L894 146M912 146L913 147L912 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M960 146L961 147L960 146M26 147L27 148L26 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M68 147L69 148L68 147M121 147L122 148L121 147M181 147L182 148L181 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M182 147L183 148L182 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M270 147L271 148L270 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M312 147L313 148L312 147M343 147L344 148L343 147M365 147L366 148L365 147M401 147L402 148L401 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M422 147L423 148L422 147M481 147L482 148L481 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M527 147L528 148L527 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M545 147L546 148L545 147M622 147L623 148L622 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M733 147L734 148L733 147M751 147L752 148L751 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M829 147L830 148L829 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M912 147L913 148L912 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M960 147L961 148L960 147M978 147L979 148L978 147M26 148L27 149L26 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M68 148L69 149L68 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M121 148L122 149L121 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M184.667 148.333L185.333 148.667L184.667 148.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M186 148L187 149L186 148M341 148L342 149L341 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M367 148L368 149L367 148M399 148L400 149L399 148M421 148L422 149L421 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M462 148L463 149L462 148M526 148L527 149L526 148M621 148L622 149L621 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M751 148L752 149L751 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M829 148L830 149L829 148M847 148L848 149L847 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M893 148L894 149L893 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M959 148L960 149L959 148M978 148L979 149L978 148M122 149L123 150L122 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M188 149L189 150L188 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M189 149L190 150L189 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M190 149L191 150L190 149M272 149L273 150L272 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M273 149L274 150L273 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M313 149L314 150L313 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M369 149L370 150L369 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M397 149L398 150L397 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M398 149L399 150L398 149M462 149L463 150L462 149M480 149L481 150L480 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M526 149L527 150L526 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M544 149L545 150L544 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M620 149L618 152L620 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M640 149L641 150L640 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M694 149L694 160L695 160L694 149M732 149L733 150L732 149M751.667 149.333L752.333 149.667L751.667 149.333M847 149L848 150L847 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M893 149L894 150L893 149M911 149L912 150L911 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M959 149L960 150L959 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M977 149L978 150L977 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M25 150L26 151L25 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M67 150L68 151L67 150M123 150L124 151L123 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M192 150L193 151L192 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M193 150L194 151L193 150M275 150L276 151L275 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M276 150L277 151L276 150M313.333 150.667L313.667 151.333L313.333 150.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M341 150L342 151L341 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M371 150L372 151L371 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M372 150L373 151L372 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M395 150L396 151L395 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M396 150L397 151L396 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M420 150L421 151L420 150M461.333 150.667L461.667 151.333L461.333 150.667M480 150L481 151L480 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M526 150L527 151L526 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M544 150L545 151L544 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M601 150L602 151L601 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M620 150L621 151L620 150M639 150L638 152L639 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M713 150L713 153L714 153L713 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M732 150L733 151L732 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M751 150L751 151L804 151L787 150L751 150M828 150L829 151L828 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M911 150L912 151L911 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M959 150L960 151L959 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M977 150L978 151L977 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M25 151L26 152L25 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M67 151L68 152L67 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M124 151L125 152L124 151M195 151L196 152L195 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M196 151L197 152L196 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M197 151L198 152L197 151M278 151L279 152L278 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M279 151L280 152L279 151M342 151L344 153L342 151M374 151L375 152L374 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M375 151L376 152L375 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M376.667 151.333L377.333 151.667L376.667 151.333M391 151L392 152L391 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M392 151L393 152L392 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M393 151L394 152L393 151M419 151L420 152L419 151M479 151L480 152L479 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M525 151L526 152L525 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M619 151L620 152L619 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M639 151L640 152L639 151M731 151L732 152L731 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M828 151L829 152L828 151M846 151L847 152L846 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M892 151L893 152L892 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M958 151L959 152L958 151M977 151L978 152L977 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M66 152L67 153L66 152M199 152L200 153L199 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M200 152L201 153L200 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M201 152L202 153L201 152M281 152L282 153L281 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M282 152L283 153L282 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M283 152L284 153L283 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M314 152L315 153L314 152M342 152L343 153L342 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M380 152L380 153L384 153L380 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M384 152L385 153L384 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M385 152L385 153L389 153L385 152M418 152L419 153L418 152M461 152L462 153L461 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M479 152L480 153L479 152M525 152L526 153L525 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M601 152L602 153L601 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M618 152L619 153L618 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M638 152L634 158L638 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M731 152L732 153L731 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M803 152L804 153L803 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M846 152L847 153L846 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M892 152L893 153L892 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M910 152L911 153L910 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M958 152L959 153L958 152M976 152L977 153L976 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M24 153L25 154L24 153M66 153L67 154L66 153M125 153L126 154L125 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M202.667 153.333L203.333 153.667L202.667 153.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M204 153L205 154L204 153M284 153L285 154L284 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M285 153L286 154L285 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M286 153L287 154L286 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M314 153L315 154L314 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M343 153L344 154L343 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M417 153L416 155L417 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M460 153L461 154L460 153M479 153L480 154L479 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M525 153L526 154L525 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M601 153L602 154L601 153M617 153L618 154L617 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M713 153L713 157L714 157L713 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M730.333 153.667L730.667 154.333L730.333 153.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M731 153L732 154L731 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M803 153L804 154L803 153M827 153L828 154L827 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M845 153L846 154L845 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M891 153L892 154L891 153M910 153L911 154L910 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M976 153L977 154L976 153M24 154L25 155L24 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M126 154L127 155L126 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M206 154L207 155L206 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M207 154L208 155L207 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M208 154L209 155L208 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M288 154L289 155L288 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M289 154L290 155L289 154M314 154L315 155L314 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M344 154L345 155L344 154M417 154L418 155L417 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M460 154L461 155L460 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M478 154L479 155L478 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M524 154L525 155L524 154M616 154L617 155L616 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M636 154L637 155L636 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M803 154L802 158L803 158L803 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M827 154L828 155L827 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M845 154L846 155L845 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M891 154L892 155L891 154M909 154L910 155L909 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M957 154L958 155L957 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M24 155L25 156L24 155M65 155L66 156L65 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M127 155L128 156L127 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M210 155L211 156L210 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M211 155L212 156L211 155M290 155L291 156L290 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M291 155L292 156L291 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M292 155L293 156L292 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M345 155L346 156L345 155M416 155L417 156L416 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M460 155L461 156L460 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M478.667 155.333L479.333 155.667L478.667 155.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M524 155L525 156L524 155M600 155L601 156L600 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M611.333 155.667L611.667 156.333L611.333 155.667M615 155L612 160L613 160L616 156L615 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M635 155L636 156L635 155M695 155L695 159L696 159L695 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M730 155L731 156L730 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M802 155L803 156L802 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M826 155L827 156L826 155M845 155L846 156L845 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M909 155L910 156L909 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M957 155L958 156L957 155M975 155L976 156L975 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M65 156L66 157L65 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M128 156L129 157L128 156M213 156L214 157L213 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M214 156L215 157L214 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M215 156L216 157L215 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M294 156L295 157L294 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M295 156L296 157L295 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M315 156L316 157L315 156M346 156L347 157L346 156M415 156L416 157L415 156M459 156L460 157L459 156M600 156L601 157L600 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M615 156L616 157L615 156M634 156L635 157L634 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M729.333 156.667L729.667 157.333L729.333 156.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M826 156L827 157L826 156M844 156L845 157L844 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M890 156L891 157L890 156M909 156L910 157L909 156M956 156L957 157L956 156M975 156L976 157L975 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M217 157L218 158L217 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M218 157L219 158L218 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M219 157L220 158L219 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M297 157L298 158L297 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M298 157L299 158L298 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M315 157L316 158L315 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M348 157L349 158L348 157M413 157L414 158L413 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M414 157L415 158L414 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M459 157L460 158L459 157M477 157L478 158L477 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M523 157L524 158L523 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M599 157L600 158L599 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M613 157L614 158L613 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M614 157L615 158L614 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M825.333 157.667L825.667 158.333L825.333 157.667M844 157L845 158L844 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M890 157L891 158L890 157M908 157L909 158L908 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M956 157L957 158L956 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M23 158L24 159L23 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M64 158L65 159L64 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M129 158L130 159L129 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M221 158L222 159L221 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M222 158L223 159L222 158M300 158L301 159L300 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M301 158L302 159L301 158M315 158L316 159L315 158M349 158L350 159L349 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M412 158L413 159L412 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M477 158L478 159L477 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M523 158L524 159L523 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M599 158L600 159L599 158M613 158L614 159L613 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M633 158C629.794 162.684 626.926 166.549 621 167L621 168C627.977 167.793 631.141 164.475 635 159L633 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M729 158L730 159L729 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M801 158L802 159L801 158M908 158L909 159L908 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M956 158L957 159L956 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M974 158L975 159L974 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M23.3333 159.667L23.6667 160.333L23.3333 159.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M64 159L65 160L64 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M130 159L131 160L130 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M224 159L225 160L224 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M225 159L226 160L225 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M226 159L227 160L226 159M303 159L304 160L303 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M304 159L305 160L304 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M350 159L351 160L350 159M411 159L412 160L411 159M458 159L459 160L458 159M522 159L523 160L522 159M599 159L600 160L599 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M632 159L633 160L632 159M695 159L695 162L696 162L695 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M728 159L729 160L728 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M825 159L826 160L825 159M843 159L844 160L843 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M889 159L890 160L889 159M131 160L132 161L131 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M228 160L229 161L228 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M229 160L230 161L229 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M230 160L231 161L230 160M306 160L307 161L306 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M307 160L308 161L307 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M352 160L353 161L352 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M409 160L410 161L409 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M410 160L411 161L410 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M458 160L459 161L458 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M476 160L477 161L476 160M522 160L523 161L522 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M598 160L599 161L598 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M611 160L607 166L608 166L611 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M631 160L632 161L631 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M714.333 160.667L714.667 161.333L714.333 160.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M728 160L729 161L728 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M800 160L801 161L800 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M843 160L844 161L843 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M889 160L890 161L889 160M907 160L908 161L907 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M955 160L956 161L955 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M973 160L974 161L973 160M63 161L64 162L63 161M132 161L133 162L132 161M232 161L233 162L232 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M233 161L234 162L233 161M309 161L310 162L309 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M310.667 161.333L311.333 161.667L310.667 161.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M316 161L317 162L316 161M353 161L354 162L353 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M354 161L355 162L354 161M407 161L408 162L407 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M408 161L409 162L408 161M457 161L458 162L457 161M476 161L477 162L476 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M522 161L523 162L522 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M598 161L596 167L597 167L598 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M611 161L612 162L611 161M630 161L631 162L630 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M727 161L726 164L727 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M728 161L729 162L728 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M800 161L801 162L800 161M824 161L825 162L824 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M842 161L843 162L842 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M888 161L889 162L888 161M907 161L908 162L907 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M973 161L974 162L973 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M22 162L23 163L22 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M63 162L64 163L63 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M235 162L236 163L235 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M236 162L237 163L236 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M237 162L238 163L237 162M312 162L313 163L312 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M313 162L314 163L313 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M314 162L315 163L314 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M316 162L317 163L316 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M355 162L356 163L355 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M356 162L357 163L356 162M405 162L406 163L405 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M406 162L407 163L406 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M457 162L458 163L457 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M475 162L476 163L475 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M521 162L522 163L521 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M610 162L611 163L610 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M695.333 162.667L695.667 163.333L695.333 162.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M714 162L714 165L715 165L714 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M824 162L825 163L824 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M842 162L843 163L842 162M888 162L889 163L888 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M954 162L955 163L954 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M22 163L23 164L22 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M63 163L64 164L63 163M133 163L134 164L133 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M239 163L240 164L239 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M240.667 163.333L241.333 163.667L240.667 163.333M315.667 163.333L316.333 163.667L315.667 163.333M357 163L358 164L357 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M358 163L359 164L358 163M403 163L404 164L403 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M404 163L405 164L404 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M457 163L458 164L457 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M475 163L476 164L475 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M476 163L477 164L476 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M521 163L522 164L521 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M597 163L598 164L597 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M609 163L610 164L609 163M727 163L728 164L727 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M799 163L800 164L799 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M823 163L824 164L823 163M842 163L843 164L842 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M888 163L889 164L888 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M906 163L907 164L906 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M954 163L955 164L954 163M972 163L973 164L972 163M22.3333 164.667L22.6667 165.333L22.3333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M134 164L135 165L134 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M242 164L243 165L242 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M243 164L244 165L243 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M244 164L245 165L244 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M360 164L361 165L360 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M361 164L362 165L361 164M401 164L402 165L401 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M402 164L403 165L402 164M456 164L457 165L456 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M608 164L609 165L608 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M715 164L716 165L715 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M727 164L728 165L727 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M799.333 164.667L799.667 165.333L799.333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M823 164L824 165L823 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M841 164L842 165L841 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M887 164L888 165L887 164M906 164L907 165L906 164M972.333 164.667L972.667 165.333L972.333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M62.3333 165.667L62.6667 166.333L62.3333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M135 165L136 166L135 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M246 165L247 166L246 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M247 165L248 166L247 165M363 165L364 166L363 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M364 165L365 166L364 165M397 165L398 166L397 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M398 165L399 166L398 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M399 165L400 166L399 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M456.333 165.667L456.667 166.333L456.333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M474 165L457 166L457 167L475 166L474 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M520.333 165.667L520.667 166.333L520.333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M596 165L597 166L596 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M627 165L628 166L627 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M714 165L696 166L696 167L715 166L714 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M726.333 165.667L726.667 166.333L726.333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M798 165L774 166L727 166L727 167L774 167L799 166L798 165M823 165C826.413 168.906 836.07 167 841 167L841 166L823 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M841 165L842 166L841 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M887 165L887 166L906 166L906 165L887 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M953.333 165.667L953.667 166.333L953.333 165.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M136 166L137 167L136 166M250 166L251 167L250 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M251 166L252 167L251 166M366 166L367 167L366 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M367 166L368 167L367 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M368.667 166.333L369.333 166.667L368.667 166.333M394 166L395 167L394 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M395 166L396 167L395 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M396 166L397 167L396 166M474 166L475 167L474 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M521 166L521 167L596 167L573 166L521 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M607 166L608 167L607 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M608 166L608 167L611 167L608 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M611 166L612 167L611 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M612 166L612 167L626 167L612 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M626 166L627 167L626 166M714 166L715 167L714 166M798 166L799 167L798 166M887 166L888 167L887 166M905 166L906 167L905 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M954 166L954 167L971 167L954 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M971 166L972 167L971 166M62 167L63 168L62 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M253 167L254 168L253 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M254 167L255 168L254 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M255 167L256 168L255 167M371.667 167.333L372.333 167.667L371.667 167.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M373.667 167.333L374.333 167.667L373.667 167.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M375 167L375 168L378 168L375 167M386 167L386 168L389 168L386 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M389 167L390 168L389 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M390.667 167.333L391.333 167.667L390.667 167.333M612.667 167.333L613.333 167.667L612.667 167.333M615.667 167.333L616.333 167.667L615.667 167.333M704 167L704 168L707 168L704 167M710.667 167.333L711.333 167.667L710.667 167.333M732 167L733 168L732 167M21.3333 168.667L21.6667 169.333L21.3333 168.667M62 168L63 169L62 168M137 168L138 169L137 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M257 168L258 169L257 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M258 168L259 169L258 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M259 168L260 169L259 168M138 169L139 170L138 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M261 169L262 170L261 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M262 169L263 170L262 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M21 170L22 171L21 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M61 170L62 171L61 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M139 170L140 171L139 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M264 170L265 171L264 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M265 170L266 171L265 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M266 170L267 171L266 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M21 171L21 174L22 174L21 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M61 171L62 172L61 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M140 171L141 172L140 171M268 171L269 172L268 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M269.667 171.333L270.333 171.667L269.667 171.333M61.3333 172.667L61.6667 173.333L61.3333 172.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M271 172L272 173L271 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M272 172L273 173L272 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M273 172L274 173L273 172M141 173L142 174L141 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M275 173L276 174L275 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M276 173L277 174L276 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M277 173L278 174L277 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M142 174L143 175L142 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M279 174L280 175L279 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M280 174L281 175L280 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M143 175L144 176L143 175M282 175L283 176L282 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M283 175L284 176L283 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M284 175L285 176L284 175M20 176L20 179L21 179L20 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M60 176L60 179L61 179L60 176M144 176L145 177L144 176M286 176L287 177L286 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M287 176L288 177L287 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M289.667 177.333L290.333 177.667L289.667 177.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M291 177L292 178L291 177M145 178L146 179L145 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M293 178L294 179L293 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M294 178L295 179L294 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M295 178L296 179L295 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M20 179L20 183L21 183L20 179M60.3333 179.667L60.6667 180.333L60.3333 179.667M146 179L147 180L146 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M297 179L298 180L297 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M298 179L299 180L298 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M147 180L148 181L147 180M300 180L301 181L300 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M301 180L302 181L301 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M302 180L303 181L302 180M60.3333 181.667L60.6667 182.333L60.3333 181.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M148 181L149 182L148 181M304 181L305 182L304 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M305 181L306 182L305 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M306 181L307 182L306 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M308 182L309 183L308 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M309.667 182.333L310.333 182.667L309.667 182.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M20 183L20 196L21 196L20 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M149 183L150 184L149 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M311 183L312 184L311 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M312 183L313 184L312 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M313 183L314 184L313 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M150 184L152 186L150 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M315 184L316 185L315 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M316 184L317 185L316 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M150 185L151 186L150 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M318.667 185.333L319.333 185.667L318.667 185.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M320 185L321 186L320 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M152 186L153 187L152 186M322 186L323 187L322 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M323 186L324 187L323 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M324 186L325 187L324 186M384 186L384 187L395 187L384 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M395 186L395 187L406 187L395 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M406 186L406 187L930 187C918.068 181.993 896.991 186 884 186L777 186L406 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M930 186L930 187L943 187L930 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M943 186L943 187L949 187L943 186M950 186L951 187L950 186M952.667 186.333L953.333 186.667L952.667 186.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M326 187L327 188L326 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M327 187L328 188L327 187M364 187L364 188L367 188L364 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M367 187L367 188L371 188L367 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M371 187L371 188L378 188L371 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M359 189L359 190L816 192L974 190L960 187.91L929 187L816 187L513 187L417 187L359 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M956 187L956 188L964 188L956 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M964 187L964 188L968 188L964 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M968 187L969 188L968 187M153 188L154 189L153 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M329 188L330 189L329 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M330 188L331 189L330 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M331 188L332 189L331 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M358 188L359 189L358 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M359 188L359 189L362 189L359 188M972 188L972 189L975 190L972 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M974 188L976 190L974 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M975 188L976 189L975 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M154 189L155 190L154 189M332 189L333 190L332 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M357 189L358 190L357 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M358 189L359 190L358 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M153 190L154 191L153 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M329 190L330 191L329 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M330 190L331 191L330 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M362.667 190.333L363.333 190.667L362.667 190.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M364.667 190.333L365.333 190.667L364.667 190.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M366 190L366 191L371 191L366 190M962 190L962 191L968 191L962 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M968.667 190.333L969.333 190.667L968.667 190.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M970 190L971 191L970 190M152 191L153 192L152 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M325 191L326 192L325 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M326 191L327 192L326 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M327 191L328 192L327 191M378 191L378 192L383 192L378 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M383 191L383 192L392 192L383 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M392 191L392 192L752 192L720 191L647 191L392 191M776 191L776 192L792 192L776 191M800 191L800 192L808 192L800 191M864 191L864 192L880 192L864 191M914 191L914 192L946 192L914 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M946 191L946 192L952 192L946 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M952 191L952 192L957 192L952 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M322 192L323 193L322 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M323 192L324 193L323 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M151 193L152 194L151 193M318 193L319 194L318 193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M319 193L320 194L319 193M150 194L151 195L150 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M314 194L315 195L314 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M315 194L316 195L315 194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M316 194L317 195L316 194M149 195L150 196L149 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M311 195L312 196L311 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M312 195L313 196L312 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M20 196L20 200L21 200L20 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M60.3333 196.667L60.6667 197.333L60.3333 196.667M148 196L149 197L148 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M307 196L308 197L307 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M308 196L309 197L308 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M309 196L310 197L309 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M148 197L149 198L148 197M304 197L305 198L304 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M305 197L306 198L305 197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M60.3333 198.667L60.6667 199.333L60.3333 198.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M147 198L148 199L147 198M300 198L301 199L300 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M301 198L302 199L301 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M302 198L303 199L302 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M146 199L147 200L146 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M296 199L297 200L296 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M297 199L298 200L297 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M298 199L299 200L298 199M20.3333 200.667L20.6667 201.333L20.3333 200.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M60.3333 200.667L60.6667 201.333L60.3333 200.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M145 200L146 201L145 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M293 200L294 201L293 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M294 200L295 201L294 200M144 201L145 202L144 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M289 201L290 202L289 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M290 201L291 202L290 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M291 201L292 202L291 201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M144 202L145 203L144 202M285 202L286 203L285 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M286 202L287 203L286 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M287 202L288 203L287 202z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M143 203L144 204L143 203M282 203L283 204L282 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M283 203L284 204L283 203M142 204L143 205L142 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M278 204L279 205L278 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M279 204L280 205L279 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M280 204L281 205L280 204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M21 205L21 208L22 208L21 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M61 205L62 206L61 205M141 205L142 206L141 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M274.667 205.333L275.333 205.667L274.667 205.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M276 205L277 206L276 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M61 206L62 207L61 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M271 206L272 207L271 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M272 206L273 207L272 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M273 206L274 207L273 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M61.3333 207.667L61.6667 208.333L61.3333 207.667M140 207L141 208L140 207M267 207L268 208L267 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M268 207L269 208L268 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M269 207L270 208L269 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M21 208L22 209L21 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M139 208L140 209L139 208M264 208L265 209L264 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M265 208L266 209L265 208M21.3333 209.667L21.6667 210.333L21.3333 209.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M138 209L139 210L138 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M260 209L261 210L260 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M261 209L262 210L261 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M262 209L263 210L262 209M510 209L511 210L510 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M511 209L511 210L514 210L511 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M514.667 209.333L515.333 209.667L514.667 209.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M516 209.424C490.265 212.835 465.98 225.533 454.32 250C434.992 290.559 461.97 328.562 507 322.711C536.601 318.864 561.946 297.017 569.255 268C577.789 234.113 550.764 204.817 516 209.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M525 209L525 210L529 210L525 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M529 209L530 210L529 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M530.667 209.333L531.333 209.667L530.667 209.333M665 210L665 211L692 211L665 210M62 210L63 211L62 210M137 210L138 211L137 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M256 210L257 211L256 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M257 210L258 211L257 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M258 210L259 211L258 210M504.667 210.333L505.333 210.667L504.667 210.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M506 210L507 211L506 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M507 210L508 211L507 210M533.667 210.333L534.333 210.667L533.667 210.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M535 210L536 211L535 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M536 210L537 211L536 210M735 210L735 211L744 211L735 210M761 210L762 211L761 210M763 210L764 211L763 210M766 210L767 211L766 210M780.667 210.333L781.333 210.667L780.667 210.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M62 211L63 212L62 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M136 211L137 212L136 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M253 211L254 212L253 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M254 211L255 212L254 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M364 211L324 321C331.354 321 348.385 324.185 354.501 319.972C360.337 315.952 364.979 296.819 366 290C388.484 290 412.503 290.417 430.985 275.482C445.933 263.404 453.874 234.243 436.985 220.38C419.041 205.652 385.623 211 364 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M404 211L404 212L411 212L404 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M411.667 211.333L412.333 211.667L411.667 211.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M413.667 211.333L414.333 211.667L413.667 211.333M501 211L502 212L501 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M502 211L503 212L502 211M538 211L539 212L538 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M539 211L540 212L539 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M540 211L541 212L540 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M590 211L588 322L614.7 321.397L628.116 305L660 260L661 260L661 322C668.562 322 682.181 324.629 688.907 320.972C698.218 315.909 706.177 298.579 712.291 290C730.678 264.198 752.586 238.66 768 211L735.184 211.603L722.424 228L691 275L690 275L692 211L665.325 211.603L652.291 228L620 275L619 275L622 211L590 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M622 211L622 216L623 216L622 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M663 211L664 212L663 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M733 211L734 212L733 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M777 211L778 212L777 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M737 321L804 321L828.298 319.972L838 296L777 296L784.419 279.028L796 278L825 278L837.49 276.972L847 254L793 254L798 237L842 237C846.243 237 854.737 238.616 858.301 235.972C863.4 232.19 866.957 217.063 868 211L803 211C796.704 211 783.795 208.544 778.394 212.028C771.977 216.167 769.197 233.052 766.576 240C756.656 266.304 743.478 293.662 737 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M868 211L869 212L868 211M886 211L887 212L886 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fdfefe",
      stroke: "none"
    },
    d: "M847 321C854.012 321 871.635 324.217 877.298 319.972C885.783 313.612 882.016 294.776 891.275 289.028C894.79 286.846 901.015 288 905 288L912.947 312L917.419 320.397L951 321L937 284C960.919 278.464 990.943 246.105 967.787 222.185C953.655 207.587 925.382 211 907 211C902.13 211 890.657 208.882 886.995 212.603C880.894 218.802 878.485 233.883 875.424 242C866.095 266.732 850.911 294.891 847 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M934 211L934 212L940 212L934 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M940.667 211.333L941.333 211.667L940.667 211.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M942 211L942 212L945 212L942 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M62.3333 212.667L62.6667 213.333L62.3333 212.667M136 212L137 213L136 212M249 212L250 213L249 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M250 212L251 213L250 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M251 212L252 213L251 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M363 212L364 213L363 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M417.667 212.333L418.333 212.667L417.667 212.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M419 212L420 213L419 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M420 212L421 213L420 212M497 212L498 213L497 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M498 212L499 213L498 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M499 212L500 213L499 212M541 212L542 213L541 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M542 212L543 213L542 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M543 212L544 213L543 212M623 212L623 216L624 216L623 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M663 212L664 213L663 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M692 212L693 213L692 212M732 212L730 216L731 216L732 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M767 212L768 213L767 212M776 212L777 213L776 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M868 212L869 213L868 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M886 212L887 213L886 212M945.667 212.333L946.333 212.667L945.667 212.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M947 212L948 213L947 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M948.667 212.333L949.333 212.667L948.667 212.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M22 213L23 214L22 213M135 213L136 214L135 213M246 213L247 214L246 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M247 213L248 214L247 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M363 213L364 214L363 213M422 213L423 214L422 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M423 213L424 214L423 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M424 213L425 214L424 213M494 213L495 214L494 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M495 213L496 214L495 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M496 213L497 214L496 213M544 213L545 214L544 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M545 213L546 214L545 213M661 213L659 218L660 218L661 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M662 213L663 214L662 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M732 213L733 214L732 213M766 213L767 214L766 213M776 213L777 214L776 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M885 213L886 214L885 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M950.667 213.333L951.333 213.667L950.667 213.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M952 213L953 214L952 213M954 213L955 214L954 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M22.3333 214.667L22.6667 215.333L22.3333 214.667M134 214L135 215L134 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M242 214L243 215L242 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M243 214L244 215L243 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M244 214L245 215L244 214M362 214L363 215L362 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M426 214L427 215L426 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M427 214L428 215L427 214M492 214L493 215L492 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M493 214L494 215L493 214M546 214L547 215L546 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M547 214L548 215L547 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M731 214L732 215L731 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M766 214L767 215L766 214M775 214L776 215L775 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M867 214L868 215L867 214M885 214L886 215L885 214M954 214L955 215L954 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M955 214L956 215L955 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M63 215L64 216L63 215M133 215L134 216L133 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M238 215L239 216L238 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M239 215L240 216L239 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M240 215L241 216L240 215M315.667 215.333L316.333 215.667L315.667 215.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M362 215L363 216L362 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M428 215L429 216L428 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M429 215L430 216L429 215M490 215L491 216L490 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M491 215L492 216L491 215M548 215L549 216L548 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M549 215L550 216L549 215M589 215L589 224L590 224L589 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M661 215L662 216L661 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M692 215L693 216L692 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M765 215L766 216L765 215M775 215L776 216L775 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M867 215L868 216L867 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M957 215L958 216L957 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M958 215L959 216L958 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M63 216L64 217L63 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M132 216L133 217L132 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M235 216L236 217L235 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M236 216L237 217L236 216M312 216L313 217L312 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M313 216L314 217L313 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M316 216L317 217L316 216M431 216L432 217L431 216M488 216L489 217L488 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M550 216L551 217L550 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M622 216L622 220L623 220L622 216M660 216L661 217L660 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M691 216L691 232L692 232L691 216M730 216L731 217L730 216M764 216L765 217L764 216M866 216L867 217L866 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M884 216L885 217L884 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M959 216L960 217L959 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M960 216L960 217L963 218L960 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M63 217L64 218L63 217M132 217L133 218L132 217M231 217L232 218L231 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M232 217L233 218L232 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M233 217L234 218L233 217M309 217L310 218L309 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M310 217L311 218L310 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M316 217L317 218L316 217M361 217L362 218L361 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M432 217L433 218L432 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M433 217L434 218L433 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M486 217L487 218L486 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M552 217L553 218L552 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M729 217L730 218L729 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M764 217L765 218L764 217M774 217L775 218L774 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M866 217L867 218L866 217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M884 217L885 218L884 217M961 217L962 218L961 217M23 218L24 219L23 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M64 218L65 219L64 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M131 218L132 219L131 218M227 218L228 219L227 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M228 218L229 219L228 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M229 218L230 219L229 218M305 218L306 219L305 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M306 218L307 219L306 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M307 218L308 219L307 218M361 218L362 219L361 218M434 218L435 219L434 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M484 218L485 219L484 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M553 218L554 219L553 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M554 218L555 219L554 218M728 218L727 220L728 218M763 218L764 219L763 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M774 218L775 219L774 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M866 218L867 219L866 218M883 218L884 219L883 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M963 218L964 219L963 218M23 219L24 220L23 219M64 219L65 220L64 219M130 219L131 220L130 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M224 219L225 220L224 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M225 219L226 220L225 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M302 219L303 220L302 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M303 219L304 220L303 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M304 219L305 220L304 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M436 219L437 220L436 219M482 219L483 220L482 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M483 219L484 220L483 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M555 219L556 220L555 219M657 219L656 222L657 222L657 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M658 219L659 220L658 219M728 219L729 220L728 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M762 219L763 220L762 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M865 219L866 220L865 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M883 219L884 220L883 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M964 219L965 220L964 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M23 220L24 221L23 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M64 220L65 221L64 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M129 220L130 221L129 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M220 220L221 221L220 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M221 220L222 221L221 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M222 220L223 221L222 220M299 220L300 221L299 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M300 220L301 221L300 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M301 220L302 221L301 220M315 220L316 221L315 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M360 220L361 221L360 220M437 220L438 221L437 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M481 220L482 221L481 220M556 220L557 221L556 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M622 220L622 229L623 229L622 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M657 220L658 221L657 220M727 220L728 221L727 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M761 220L762 221L761 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M762 220L763 221L762 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M773 220L774 221L773 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M865 220L866 221L865 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M883 220L884 221L883 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M966 220L967 221L966 220M65 221L66 222L65 221M128 221L129 222L128 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M217 221L218 222L217 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M218 221L219 222L218 221M296 221L297 222L296 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M297 221L298 222L297 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M298 221L299 222L298 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M315 221L316 222L315 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M360 221L361 222L360 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M438 221L439 222L438 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M479 221L480 222L479 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M557 221L558 222L557 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M725 221L725 223L727 221L725 221M761 221L762 222L761 221M772.333 221.667L772.667 222.333L772.333 221.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M773 221L774 222L773 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M882 221L883 222L882 221M967 221L967 222L969 224L970 224L967 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M24.3333 222.667L24.6667 223.333L24.3333 222.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M65 222L66 223L65 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M128 222L129 223L128 222M213 222L214 223L213 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M214 222L215 223L214 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M215 222L216 223L215 222M293 222L294 223L293 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M294.667 222.333L295.333 222.667L294.667 222.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M315 222L316 223L315 222M359 222L360 223L359 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M439 222L441 224L439 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M440 222L441 223L440 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M478 222L479 223L478 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M558 222L559 223L558 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M656 222L657 223L656 222M726 222L727 223L726 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M760 222L761 223L760 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M864 222L865 223L864 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M882 222L883 223L882 222M968 222L969 223L968 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M65 223L66 224L65 223M127 223L128 224L127 223M209 223L210 224L209 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M210 223L211 224L210 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M211 223L212 224L211 223M290 223L291 224L290 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M291 223L292 224L291 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M359 223L360 224L359 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M475.667 223.333L476.333 223.667L475.667 223.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M477 223L478 224L477 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M559 223L560 224L559 223M655 223L656 224L655 223M725 223L726 224L725 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M759 223L760 224L759 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M772 223L773 224L772 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M864 223L865 224L864 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M24 224L25 225L24 224M126 224L127 225L126 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M206 224L207 225L206 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M207 224L208 225L207 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M287 224L288 225L287 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M288 224L289 225L288 224M314 224L315 225L314 224M359 224L360 225L359 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M441 224L442 225L441 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M475 224L476 225L475 224M560 224L561 225L560 224M589 224L589 231L590 231L589 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M654 224L655 225L654 224M724 224L722 228L723 228L724 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M863 224L864 225L863 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M881 224L882 225L881 224M970 224L972 228L973 228L970 224M24 225L25 226L24 225M66 225L67 226L66 225M125 225L126 226L125 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M202 225L203 226L202 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M203 225L204 226L203 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M204 225L205 226L204 225M284 225L285 226L284 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M285 225L286 226L285 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M314 225L315 226L314 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M358 225L359 226L358 225M442 225L443 226L442 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M474 225L475 226L474 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M561 225L562 226L561 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M724 225L725 226L724 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M758 225L759 226L758 225M771 225L772 226L771 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M863 225L864 226L863 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M881 225L882 226L881 225M970 225L971 226L970 225M66 226L67 227L66 226M198 226L199 227L198 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M199 226L200 227L199 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M200 226L201 227L200 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M281 226L282 227L281 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M282 226L283 227L282 226M358 226L359 227L358 226M442 226L443 227L442 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M472 226L473 227L472 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M473 226L474 227L473 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M562 226L563 227L562 226M652 226L651 229L652 229L652 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M653 226L654 227L653 226M723 226L724 227L723 226M757 226L756 228L757 226M771 226L772 227L771 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M863 226L864 227L863 226M880 226L881 227L880 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M25 227L26 228L25 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M67 227L68 228L67 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M124 227L125 228L124 227M195 227L196 228L195 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M196 227L197 228L196 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M278 227L279 228L278 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M279 227L280 228L279 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M443 227L444 228L443 227M471 227L472 228L471 227M563 227L564 228L563 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M652 227L653 228L652 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M757 227L758 228L757 227M770.333 227.667L770.667 228.333L770.333 227.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M862 227L863 228L862 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M880 227L881 228L880 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M971 227L972 228L971 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M25 228L26 229L25 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M67 228L68 229L67 228M123 228L124 229L123 228M191 228L192 229L191 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M192 228L193 229L192 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M193 228L194 229L193 228M274 228L275 229L274 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M275 228L276 229L275 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M276 228L277 229L276 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M313 228L314 229L313 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M357 228L358 229L357 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M443 228L444 229L443 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M470 228L471 229L470 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M563 228L564 229L563 228M621 228L621 234L622 234L621 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M756 228L757 229L756 228M862 228L863 229L862 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M880 228L881 229L880 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M972 228L973 229L972 228M122 229L123 230L122 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M187.667 229.333L188.333 229.667L187.667 229.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M189 229L190 230L189 229M271 229L272 230L271 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M272 229L273 230L272 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M273 229L274 230L273 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M313 229L314 230L313 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M357 229L358 230L357 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M444 229L445 230L444 229M469 229L470 230L469 229M564 229L565 230L564 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M651 229L652 230L651 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M720 229L721 230L720 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M721 229L722 230L721 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M755 229L756 230L755 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M770 229L771 230L770 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M879 229L880 230L879 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M972 229L973 230L972 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M973.333 229.667L973.667 230.333L973.333 229.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M26 230L27 231L26 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M68 230L69 231L68 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M121 230L122 231L121 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M184 230L185 231L184 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M185 230L186 231L185 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M186 230L187 231L186 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M444 230L445 231L444 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M468 230L469 231L468 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M565 230L566 231L565 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M650 230L651 231L650 230M720 230L721 231L720 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M754 230L755 231L754 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M755 230L756 231L755 230M769 230L770 231L769 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M861 230L862 231L861 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M879 230L880 231L879 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M26 231L27 232L26 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M180 231L181 232L180 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M181 231L182 232L181 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M182 231L183 232L182 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M270 231L271 232L270 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M312 231L313 232L312 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M356 231L357 232L356 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M445 231L446 232L445 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M467 231L468 232L467 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M565 231L566 232L565 231M589 231L589 244L590 244L589 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M649 231L650 232L649 231M754 231L755 232L754 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M769 231L770 232L769 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M861 231L862 232L861 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M879 231L880 232L879 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M973 231L974 232L973 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M69 232L70 233L69 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M120 232L121 233L120 232M177 232L178 233L177 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M178 232L179 233L178 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M312 232L313 233L312 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M356 232L357 233L356 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M445 232L446 233L445 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M466 232L467 233L466 232M566 232L567 233L566 232M648 232L649 233L648 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M691 232L691 241L692 241L691 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M719 232L720 233L719 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M753 232L754 233L753 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M769 232L770 233L769 232M860 232L861 233L860 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M878 232L879 233L878 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M973 232L974 233L973 232M27 233L28 234L27 233M69 233L70 234L69 233M119 233L120 234L119 233M173 233L174 234L173 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M174 233L175 234L174 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M175 233L176 234L175 233M269 233L270 234L269 233M312 233L313 234L312 233M355 233L356 234L355 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M445 233L446 234L445 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M465 233L466 234L465 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M566 233L567 234L566 233M648 233L649 234L648 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M718 233L719 234L718 233M752 233L753 234L752 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M768 233L769 234L768 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M860 233L861 234L860 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M878 233L879 234L878 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M974 233L975 234L974 233M27 234L28 235L27 234M70 234L71 235L70 234M118 234L119 235L118 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M169.667 234.333L170.333 234.667L169.667 234.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M171 234L172 235L171 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M311 234L312 235L311 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M355 234L356 235L355 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M464 234L465 235L464 234M567 234L568 235L567 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M621 234L621 237L622 237L621 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M647 234L648 235L647 234M717 234L718 235L717 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M751 234L752 235L751 234M768 234L769 235L768 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M860 234L861 235L860 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M974 234L975 235L974 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M70 235L71 236L70 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M117 235L118 236L117 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M166 235L167 236L166 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M167 235L168 236L167 235M268 235L269 236L268 235M311 235L312 236L311 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M446 235L447 236L446 235M463 235L464 236L463 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M567 235L568 236L567 235M717 235L718 236L717 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M751 235L752 236L751 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M859 235L860 236L859 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M877 235L878 236L877 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M974 235L974 238L975 238L974 235M28 236L29 237L28 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M71 236L72 237L71 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M162 236L163 237L162 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M163 236L164 237L163 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M164 236L165 237L164 236M354 236L355 237L354 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M446 236L447 237L446 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M463 236L464 237L463 236M512 236L512 237L520 237L512 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M568 236L569 237L568 236M645 236L646 237L645 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M646 236L647 237L646 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M716 236L717 237L716 236M750 236L751 237L750 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M767 236L768 237L767 236M859 236L860 237L859 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M877 236L878 237L877 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M28 237L29 238L28 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M71 237L72 238L71 237M116 237L117 238L116 237M159 237L160 238L159 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M160 237L161 238L160 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M267 237L268 238L267 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M310 237L311 238L310 237M354 237L355 238L354 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M386 237L385 240L386 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M377 266C382.765 266 388.286 265.812 394 264.999C397.903 264.444 401.62 263.597 404.985 261.438C425.674 248.157 399.064 227.046 386.853 238.603C383.7 241.588 382.323 247.974 381.028 252C379.54 256.625 377.496 261.157 377 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M401.667 237.333L402.333 237.667L401.667 237.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M403 237L404 238L403 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M404 237L405 238L404 237M446 237L446 246L447 246L446 237M462 237L463 238L462 237M507 237L508 238L507 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M508 237L509 238L508 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M509 237L509 238L520 238L509 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M488 255C474.314 262.769 479.239 287.707 492.001 293.698C517.208 305.531 552.229 266.597 533.292 244.13C523.402 232.397 488.664 237.401 488 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M521 237L521 238L526 239L526 238L521 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M522 237L523 238L522 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M523.667 237.333L524.333 237.667L523.667 237.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M568 237L569 238L568 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M621 237L621 248L622 248L621 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M645 237L646 238L645 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M715 237L716 238L715 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M749 237L750 238L749 237M767 237L768 238L767 237M798 237L799 238L798 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M799 237L800 238L799 237M840 237L841 238L840 237M842 237L843 238L842 237M844 237L845 238L844 237M846 237L847 238L846 237M848.667 237.333L849.333 237.667L848.667 237.333M856 237L857 238L856 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M909 237L909 238L930 238L909 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M975 237L975 248L976 248L975 237M28 238L29 239L28 238M72 238L73 239L72 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M115 238L116 239L115 238M155 238L156 239L155 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M156 238L157 239L156 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M157 238L158 239L157 238M310 238L311 239L310 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M385 238L386 239L385 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M406 238L407 239L406 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M407 238L408 239L407 238M461 238L462 239L461 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M504 238L505 239L504 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M505 238L506 239L505 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M526 238L527 239L526 238M568 238L569 239L568 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M569.333 238.667L569.667 239.333L569.333 238.667M644 238L645 239L644 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M715 238L716 239L715 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M766 238L767 239L766 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M798 238L799 239L798 238M876 238L877 239L876 238M908 238L909 239L908 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M908 241L912 239L908 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#252a2f",
      stroke: "none"
    },
    d: "M901 263C907.654 263 914.351 263.221 921 262.945C924.562 262.797 927.778 262.11 931 260.546C933.302 259.429 935.694 258.08 937.502 256.239C952.988 240.466 918.346 231.478 909.509 240.434C904.618 245.39 902.378 256.377 901 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M931.667 238.333L932.333 238.667L931.667 238.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M933 238L934 239L933 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M934 238L935 239L934 238M29 239L30 240L29 239M72 239L73 240L72 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M114 239L115 240L114 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M151 239L152 240L151 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M152 239L153 240L152 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M153 239L154 240L153 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M266 239L267 240L266 239M353 239L354 240L353 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M408 239L409 240L408 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M409 239L410 240L409 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M460 239L461 240L460 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M502 239L503 240L502 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M503 239L503 240L506 240L503 239M527 239L530 241L530 240L527 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M528 239L529 240L528 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M644 239L645 240L644 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M714 239L715 240L714 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M748 239L749 240L748 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M766 239L767 240L766 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M798 239L799 240L798 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M876 239L877 240L876 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M934.667 239.333L935.333 239.667L934.667 239.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M936 239L937 240L936 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M29 240L30 241L29 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M73 240L74 241L73 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M113 240L114 241L113 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M148 240L149 241L148 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M149 240L150 241L149 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M309 240L310 241L309 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M353 240L354 241L353 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M410 240L411 241L410 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M459 240L460 241L459 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M500 240L501 241L500 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M501 240L502 241L501 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M530 240L531 241L530 240M569.333 240.667L569.667 241.333L569.333 240.667M643 240L644 241L643 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M713 240L714 241L713 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M747 240L746 242L747 240M766 240L767 241L766 240M797 240L798 241L797 240M907 240L908 241L907 240M938 240L939 241L938 240M144 241L145 242L144 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M145 241L146 242L145 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M146 241L147 242L146 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M265 241L266 242L265 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M309 241L310 242L309 241M352 241L353 242L352 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M384 241L385 242L384 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M411 241L412 242L411 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M459 241L460 242L459 241M498 241L499 242L498 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M499 241L500 242L499 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M531 241L532 242L531 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M640 244L643 241L640 244M691 241L691 250L692 250L691 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M713 241L714 242L713 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M747 241L748 242L747 241M765 241L766 242L765 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M797 241L798 242L797 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M875 241L876 242L875 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M907 241L908 242L907 241M939 241L940 242L939 241M30 242L31 243L30 242M74 242L75 243L74 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M112 242L113 243L112 242M141 242L142 243L141 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M142 242L143 243L142 242M264 242L265 243L264 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M308 242L309 243L308 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M352 242L353 243L352 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M384 242L385 243L384 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M412 242L413 243L412 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M458 242L459 243L458 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M497.667 242.333L498.333 242.667L497.667 242.333M532 242L533 243L532 242M570.333 242.667L570.667 243.333L570.333 242.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M712 242L713 243L712 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M746 242L744 246L746 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M765 242L766 243L765 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M797 242L796 245L797 242M907 242L905 248L906 248L907 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M940 242L941 243L940 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M111 243L112 244L111 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M137 243L138 244L137 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M138 243L139 244L138 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M264 243L265 244L264 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M308 243L309 244L308 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M352 243L353 244L352 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M412 243L413 244L412 243M457 243L458 244L457 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M495 243L496 244L495 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M496 243L497 244L496 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M533 243L535 245L533 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M641 243L642 244L641 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M711 243L710 245L711 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M745 243L746 244L745 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M796 243L797 244L796 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M874 243L875 244L874 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M906 243L907 244L906 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M940 243L942 246L940 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M31 244L32 245L31 244M75 244L76 245L75 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M110 244L111 245L110 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M133 244L134 245L133 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M134 244L135 245L134 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M135 244L136 245L135 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M263 244L264 245L263 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M351 244L352 245L351 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M383 244L384 245L383 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M413.333 244.667L413.667 245.333L413.333 244.667M457 244L458 245L457 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M494 244L495 245L494 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M495 244L496 245L495 244M533 244L534 245L533 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M570 244L571 245L570 244M640 244L641 245L640 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M711 244L712 245L711 244M744 244L745 245L744 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M764 244L765 245L764 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M874 244L875 245L874 244M941 244L942 245L941 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M31 245L32 246L31 245M76 245L77 246L76 245M109 245L110 246L109 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M130 245L131 246L130 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M131 245L132 246L131 245M262 245L263 246L262 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M307 245L308 246L307 245M351 245L352 246L351 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M383 245L384 246L383 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M456 245L457 246L456 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M492 247L495 245L492 247M534 245L536 247L534 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M535 245L536 246L535 245M570 245L571 246L570 245M620 245L620 251L621 251L620 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M639 245L637 249L638 249L639 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M710 245L711 246L710 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M764 245L765 246L764 245M795 245L796 246L795 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M873 245L874 246L873 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M32 246L33 247L32 246M126 246L127 247L126 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M127 246L128 247L127 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M262 246L263 247L262 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M307 246L308 247L307 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M382 246L383 247L382 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M413 246L414 247L413 246M446.333 246.667L446.667 247.333L446.333 246.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M634 246L635 247L634 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M639 246L640 247L639 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M709 246L710 247L709 246M743 246L744 247L743 246M763 246L764 247L763 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M795 246L796 247L795 246M873 246L874 247L873 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M905 246L906 247L905 246M974 246L974 249L975 249L974 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M32 247L33 248L32 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M77 247L78 248L77 247M108 247L109 248L108 247M122 247L123 248L122 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M123 247L124 248L123 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M124 247L125 248L124 247M261 247L262 248L261 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M306 247L307 248L306 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M350 247L351 248L350 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M382 247L383 248L382 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M413 247L414 248L413 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M455 247L456 248L455 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M491 247L492 248L491 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M536 247L537 248L536 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M638 247L639 248L638 247M742 247L743 248L742 247M763 247L764 248L763 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M873 247L874 248L873 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M78 248L79 249L78 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M107 248L108 249L107 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M119 248L120 249L119 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M120 248L121 249L120 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M121 248L122 249L121 248M306 248L307 249L306 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M350 248L351 249L350 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M413.333 248.667L413.667 249.333L413.333 248.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M446 248L447 249L446 248M490.333 248.667L490.667 249.333L490.333 248.667M536.333 248.667L536.667 249.333L536.333 248.667M571 248L571 251L572 251L571 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M708 248L709 249L708 248M741 248L742 249L741 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M742 248L743 249L742 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M763 248L764 249L763 248M794 248L795 249L794 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M795 248L796 249L795 248M872 248L873 249L872 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M904 248L905 249L904 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M33 249L34 250L33 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M106 249L107 250L106 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M115 249L116 250L115 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M116 249L117 250L116 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M117 249L118 250L117 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M260 249L261 250L260 249M305 249L306 250L305 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M349 249L350 250L349 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M381 249L382 250L381 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M454 249L455 250L454 249M489 249L490 250L489 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M537 249L538 250L537 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M636 249L635 251L636 249M707 249L708 250L707 249M741 249L742 250L741 249M762 249L763 250L762 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M794 249L795 250L794 249M872 249L873 250L872 249M904 249L905 250L904 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M941 249L942 250L941 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M974 249L975 250L974 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M79 250L80 251L79 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M105 250L106 251L105 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M112 250L113 251L112 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M113 250L114 251L113 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M259 250L260 251L259 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M305 250L306 251L305 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M349 250L350 251L349 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M381 250L382 251L381 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M413 250L414 251L413 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M453 250L454 251L453 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M488 250L489 251L488 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M537 250L538 251L537 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M621.333 250.667L621.667 251.333L621.333 250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M636 250L637 251L636 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M740 250L741 251L740 250M762 250L763 251L762 250M941 250L942 251L941 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M34 251L35 252L34 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M80 251L81 252L80 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M108 251L109 252L108 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M109 251L110 252L109 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M110 251L111 252L110 251M258 251L259 252L258 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M304 251L305 252L304 251M349 251L350 252L349 251M445 251L446 252L445 251M453 251L454 252L453 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M537 251L538 252L537 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M571 251L571 257L572 257L571 251M620 251L620 254L621 254L620 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M633 251L633 253L635 253L633 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M635 251L636 252L635 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M691 251L691 267L692 267L691 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M706 251L707 252L706 251M739 251L740 252L739 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M740 251L739 253L741 253L740 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M762 251L763 252L762 251M793 251L794 252L793 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M871 251L872 252L871 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M903 251L904 252L903 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M904 251L905 252L904 251M940 251L939 255L940 255L940 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M941 251L942 252L941 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M34 252L35 253L34 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M104.667 252.333L105.333 252.667L104.667 252.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M106 252L107 253L106 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M258 252L259 253L258 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M304 252L305 253L304 252M348 252L349 253L348 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M380 252L381 253L380 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M412 252L413 253L412 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M445 252L446 253L445 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M452 252L453 253L452 252M487 252L488 253L487 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M705 252L706 253L705 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M761 252L762 253L761 252M793 252L807 254L847 254L847 253L793 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M871 252L872 253L871 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M903 252L901 260L902 260L903 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M973 252L974 253L973 252M35 253L36 254L35 253M81 253L82 254L81 253M257 253L258 254L257 253M303 253L304 254L303 253M348 253L349 254L348 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M380 253L381 254L380 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M412 253L413 254L412 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M445 253L446 254L445 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M452 253L453 254L452 253M486 253L487 254L486 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M538 253L539 254L538 253M634 253L635 254L634 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M704 253L705 254L704 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M738 253L739 254L738 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M761 253L762 254L761 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M940 253L941 254L940 253M973 253L974 254L973 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M35 254L36 255L35 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M82 254L83 255L82 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M256 254L257 255L256 254M303 254L304 255L303 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M379 254L380 255L379 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M411 254L412 255L411 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M452 254L453 255L452 254M485 254L486 255L485 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M486.667 254.333L487.333 254.667L486.667 254.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M538 254L538 257L539 257L538 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M620 254L620 263L621 263L620 254M632.333 254.667L632.667 255.333L632.333 254.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M633 254L634 255L633 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M704 254L705 255L704 254M737 254L736 256L737 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M738 254L739 255L738 254M847.333 254.667L847.667 255.333L847.333 254.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M870 254L871 255L870 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M902 254L903 255L902 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M973 254L971 260L972 260L973 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M36 255L37 256L36 255M83 255L84 256L83 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M255 255L256 256L255 255M347 255L348 256L347 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M379 255L380 256L379 255M411 255L412 256L411 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M444 255L445 256L444 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M451 255L452 256L451 255M485 255L486 256L485 255M703 255L704 256L703 255M737 255L738 256L737 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M760 255L761 256L760 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M846 255L847 256L846 255M870 255L871 256L870 255M939 255L940 256L939 255M972 255L973 256L972 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M84 256L85 257L84 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M302 256L303 257L302 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M347 256L348 257L347 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M379.333 256.667L379.667 257.333L379.333 256.667M410 256L411 257L410 256M444 256L445 257L444 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M451 256L452 257L451 256M484 256L485 257L484 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M588 256L588 263L589 263L588 256M630.667 256.333L631.333 256.667L630.667 256.333M702 256L701 258L702 256M736 256L737 257L736 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M760 256L761 257L760 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M846 256L847 257L846 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M869 256L870 257L869 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M901 256L902 257L901 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M937 256L927 262L927 263C930.861 261.683 935.881 260.277 937 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M938 256L939 257L938 256M972 256L973 257L972 256M37 257L38 258L37 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M85 257L86 258L85 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M254 257L255 258L254 257M378 257L379 258L378 257M410 257L411 258L410 257M443 257L444 258L443 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M450 257L451 258L450 257M484 257L485 258L484 257M538 257L538 260L539 260L538 257M571.333 257.667L571.667 258.333L571.333 257.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M631 257L632 258L631 257M702 257L703 258L702 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M735 257L736 258L735 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M759 257L760 258L759 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M869 257L870 258L869 257M901 257L902 258L901 257M937 257L938 258L937 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M38 258L39 259L38 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M86 258L87 259L86 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M253 258L254 259L253 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M301 258L302 259L301 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M346 258L347 259L346 258M378 258L379 259L378 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M409 258L410 259L409 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M443 258L444 259L443 258M450 258L451 259L450 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M483 258L484 259L483 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M630 258L631 259L630 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M701 258L702 259L701 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M734 258L735 259L734 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M735 258L736 259L735 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M759 258L760 259L759 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M845 258L846 259L845 258M869 258L870 259L869 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M936 258L937 259L936 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M971 258L972 259L971 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M38 259L39 260L38 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M86 259L87 260L86 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M252 259L253 260L252 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M300 259L301 260L300 259M346 259L347 260L346 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M378 259L379 260L378 259M407 259L406 261L407 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M408 259L409 260L408 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M443 259L444 260L443 259M483 259L484 260L483 259M629 259L622 270L623 270L629 259M700 259L699 261L700 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M759 259L760 260L759 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M845 259L846 260L845 259M868 259L869 260L868 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M900 259L901 260L900 259M935 259L936 260L935 259M39 260L40 261L39 260M87 260L88 261L87 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M251 260L252 261L251 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M300 260L301 261L300 260M345 260L346 261L345 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M377 260L378 261L377 260M407 260L408 261L407 260M442 260L443 261L442 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M449 260L450 261L449 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M482 260L483 261L482 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M484 260L485 261L484 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M538.333 260.667L538.667 261.333L538.333 260.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M629 260L630 261L629 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M660 260L661 261L660 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M700 260L701 261L700 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M733 260L734 261L733 260M758 260L759 261L758 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M844 260L845 261L844 260M868 260L869 261L868 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M900 260L901 261L900 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M933 260L934 261L933 260M970 260L971 261L970 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M39 261L40 262L39 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M88 261L89 262L88 261M250 261L251 262L250 261M299 261L300 262L299 261M345 261L346 262L345 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M377 261L378 262L377 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M405 261L406 262L405 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M442 261L443 262L442 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M449 261L450 262L449 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M482 261L483 262L482 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M570.333 261.667L570.667 262.333L570.333 261.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M628 261L629 262L628 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M659 261L660 262L659 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M660 261L659 265L660 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M690 261L690 275L691 275L690 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M699 261L700 262L699 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M732 261L731 263L732 261M758 261L759 262L758 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M844 261L845 262L844 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M900 261L899 264L922 264L922 263L900 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M931 261L932 262L931 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M970 261L971 262L970 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M40 262L41 263L40 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M89 262L90 263L89 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M249 262L250 263L249 262M403 262L404 263L403 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M404 262L405 263L404 262M441 262L442 263L441 262M449 262L450 263L449 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M483 262L484 263L483 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M538.333 262.667L538.667 263.333L538.333 262.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M698 262L699 263L698 262M732 262L733 263L732 262M757.333 262.667L757.667 263.333L757.333 262.667M844 262L845 263L844 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M867 262L868 263L867 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M899 262L900 263L899 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M924.667 262.333L925.333 262.667L924.667 262.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M928 262L929 263L928 262M969 262L970 263L969 262M90 263L91 264L90 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M248 263L249 264L248 263M298 263L299 264L298 263M344 263L345 264L344 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M376 263L377 264L376 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M401 263L402 264L401 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M402 263L403 264L402 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M441 263L442 264L441 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M481 263L482 264L481 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M482 263L483 264L482 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M570 263L571 264L570 263M588 263L588 272L589 272L588 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M619 263L619 269L620 269L619 263M627 263L628 264L627 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M658 263L659 264L658 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M698 263L699 264L698 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M731 263L732 264L731 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M843 263L844 264L843 263M867 263L868 264L867 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M922.667 263.333L923.333 263.667L922.667 263.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M924.667 263.333L925.333 263.667L924.667 263.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M969 263L970 264L969 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M41 264L42 265L41 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M91 264L92 265L91 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M247 264L248 265L247 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M297 264L298 265L297 264M344 264L345 265L344 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M376.333 264.667L376.667 265.333L376.333 264.667M397 264L398 265L397 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M398 264L399 265L398 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M399 264L400 265L399 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M440 264L441 265L440 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M448 264L449 265L448 264M481 264L482 265L481 264M570.333 264.667L570.667 265.333L570.333 264.667M620 264L621 265L620 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M626 264L627 265L626 264M657 264L658 265L657 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M693 264L695 266L693 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M697 264L698 265L697 264M730 264L731 265L730 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M757 264L758 265L757 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M843 264L844 265L843 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M866 264L867 265L866 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M968 264L969 265L968 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M92 265L93 266L92 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M246 265L247 266L246 265M297 265L298 266L297 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M375 265L376 266L375 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M390.667 265.333L391.333 265.667L390.667 265.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M392.667 265.333L393.333 265.667L392.667 265.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M394.667 265.333L395.333 265.667L394.667 265.333M439 265L440 266L439 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M448 265L449 266L448 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M537 265L536 267L537 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M656 265L657 266L656 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M696 265L697 266L696 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M729 265L730 266L729 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M730 265L731 266L730 265M756 265L757 266L756 265M843 265L844 266L843 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M866 265L867 266L866 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M967 265L966 267L967 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M42 266L43 267L42 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M93 266L94 267L93 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M245 266L246 267L245 266M296 266L297 267L296 266M343 266L344 267L343 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M439 266L440 267L439 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M448 266L449 267L448 266M480 266L481 267L480 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M481 266L482 267L481 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M537 266L538 267L537 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M620 266L619 274L620 274L620 266M656.667 266.333L657.333 266.667L656.667 266.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M696 266L697 267L696 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M729 266L730 267L729 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M756 266L757 267L756 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M842 266L843 267L842 266M866 266L867 267L866 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M967 266L968 267L967 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M43 267L44 268L43 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M94 267L95 268L94 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M244 267L245 268L244 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M295 267L296 268L295 267M343 267L344 268L343 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M438 267L439 268L438 267M480 267L481 268L480 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M537 267L538 268L537 267M569 267L570 268L569 267M624 267L625 268L624 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M655 267L656 268L655 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M660 267L660 313L661 313C661 299.997 665.01 278.939 660 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M695 267L696 268L695 267M728 267L729 268L728 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M756 267L757 268L756 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M842 267L843 268L842 267M865 267L866 268L865 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M44 268L45 269L44 268M95 268L96 269L95 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M243 268L244 269L243 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M295 268L296 269L295 268M342 268L343 269L342 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M437 268L436 270L437 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M480 268L481 269L480 268M536 268L537 269L536 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M569 268L570 269L569 268M623 268L624 269L623 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M654 268L655 269L654 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M655 268L656 269L655 268M691 268L692 269L691 268M694 268L691 273L692 273L694 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M727 268L728 269L727 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M754.667 268.333L755.333 268.667L754.667 268.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M865 268L866 269L865 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M965 268L966 269L965 268M44 269L45 270L44 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M96 269L97 270L96 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M97 269L98 270L97 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M242 269L243 270L242 269M294 269L295 270L294 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M342 269L343 270L342 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M437 269L438 270L437 269M447 269L448 270L447 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M536 269L537 270L536 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M569.333 269.667L569.667 270.333L569.333 269.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M619 269L619 272L620 272L619 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M654 269L653 271L655 271L654 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M694 269L695 270L694 269M726 269L727 270L726 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M734 269L735 270L734 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M755 269L756 270L755 269M841 269L842 270L841 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M964 269L965 270L964 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M45 270L46 271L45 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M98 270L99 271L98 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M241 270L242 271L241 270M293 270L294 271L293 270M342 270L343 271L342 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M436 270L437 271L436 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M447 270L448 271L447 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M479 270L479 279L480 279L479 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M480 270L481 271L480 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M536 270L537 271L536 270M568.333 270.667L568.667 271.333L568.333 270.667M622 270L623 271L622 270M693 270L694 271L693 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M726.333 270.667L726.667 271.333L726.333 270.667M841 270L842 271L841 270M864 270L865 271L864 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M963 270L964 271L963 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M46 271L47 272L46 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M99 271L100 272L99 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M239 271L240 272L239 271M293 271L294 272L293 271M341 271L342 272L341 271M435 271L436 272L435 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M447.333 271.667L447.667 272.333L447.333 271.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M535 271L536 272L535 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M621 271L622 272L621 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M652 271L653 272L652 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M657 271L658 272L657 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M725 271L726 272L725 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M754 271L755 272L754 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M840 271L841 272L840 271M864 271L865 272L864 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M962.667 271.333L963.333 271.667L962.667 271.333M46 272L47 273L46 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M100 272L101 273L100 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M238 272L239 273L238 272M292 272L293 273L292 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M341 272L342 273L341 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M434 272L435 273L434 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M535 272L536 273L535 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M568 272L569 273L568 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M588 272L588 285L589 285L588 272M651 272L652 273L651 272M724 272L725 273L724 272M754 272L755 273L754 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M840 272L841 273L840 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M961 272L962 273L961 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M47 273L48 274L47 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M101 273L102 274L101 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M102 273L103 274L102 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M237 273L238 274L237 273M291 273L292 274L291 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M433 273L434 274L433 273M534 273L533 276L534 276L534 273M651 273L650 276L651 273M724 273L725 274L724 273M753 273L754 274L753 273M840 273L841 274L840 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M863 273L864 274L863 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M959 273L960 274L959 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M960 273L959 275L961 275L960 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M48 274L49 275L48 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M103 274L104 275L103 274M235 274L236 275L235 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M236 274L237 275L236 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M340 274L341 275L340 274M432 274L433 275L432 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M534 274L535 275L534 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M567 274L568 275L567 274M619 274L620 275L619 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M723 274L724 275L723 274M753 274L754 275L753 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M839 274L840 275L839 274M863 274L864 275L863 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M958 274L959 275L958 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M48 275L49 276L48 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M104 275L105 276L104 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M234 275L235 276L234 275M290 275L291 276L290 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M340 275L341 276L340 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M431 275L432 276L431 275M567 275L568 276L567 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M649 275L650 276L649 275M722 275L723 276L722 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M723 275L724 276L723 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M753 275L754 276L753 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M839 275L840 276L839 275M862 275L863 276L862 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M956 275L955 277L956 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M957 275L958 276L957 275M49 276L50 277L49 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M105 276L106 277L105 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M106 276L107 277L106 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M233 276L234 277L233 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M289 276L290 277L289 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M339 276L340 277L339 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M429 276L430 277L429 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M430 276L431 277L430 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M533 276L534 277L533 276M566 276L567 277L566 276M648 276L649 277L648 276M721 276L722 277L721 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M752 276L753 277L752 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M862 276L863 277L862 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M956 276L957 277L956 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M50 277L51 278L50 277M107 277L108 278L107 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M231 277L232 278L231 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M288 277L289 278L288 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M339 277L340 278L339 277M428 277L429 278L428 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M532 277L530 281L531 281L532 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M566 277L567 278L566 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M648 277L649 278L648 277M721 277L722 278L721 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M752 277L753 278L752 277M838 277L839 278L838 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M953 277L954 278L953 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M954 277L956 279L956 277L954 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M51 278L52 279L51 278M108 278L109 279L108 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M109 278L110 279L109 278M229 278L230 279L229 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M230 278L231 279L230 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M288 278L289 279L288 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M339 278L340 279L339 278M426 278L427 279L426 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M427 278L428 279L427 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M532 278L533 279L532 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M647 278L648 279L647 278M720 278L721 279L720 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M783 278L784 279L783 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M837 278L838 279L837 278M861 278L862 279L861 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M951 278L952 279L951 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M952.667 278.333L953.333 278.667L952.667 278.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M52 279L53 280L52 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M110 279L111 280L110 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M228 279L229 280L228 279M287 279L288 280L287 279M338 279L339 280L338 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M425 279L426 280L425 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M531 279L532 280L531 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M565 279L566 280L565 279M646 279L647 280L646 279M719 279L720 280L719 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M751 279L752 280L751 279M783 279L784 280L783 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M861 279L862 280L861 279M949 279L950 280L949 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M950 279L951 280L950 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M951 279L952 280L951 279M52 280L53 281L52 280M112 280L113 281L112 280M226 280L227 281L226 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M227 280L228 281L227 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M286 280L287 281L286 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M338 280L339 281L338 280M423 280L424 281L423 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M424 280L425 281L424 280M480 280L481 281L480 280M565 280L566 281L565 280M719 280L720 281L719 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M751 280L752 281L751 280M782 280L783 281L782 280M947 280L948 281L947 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M948 280L949 281L948 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M53 281L54 282L53 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M113 281L114 282L113 281M225 281L226 282L225 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M285 281L286 282L285 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M422 281L423 282L422 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M480.333 281.667L480.667 282.333L480.333 281.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M529 281L530 282L529 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M564 281L565 282L564 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M645 281L643 286L644 286L645 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M718 281L719 282L718 281M782 281L783 282L782 281M860 281L861 282L860 281M945 281L946 282L945 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M937 284L939 288L948 282L937 284M54 282L55 283L54 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M115 282L116 283L115 282M223 282L224 283L223 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M284 282L285 283L284 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M337 282L338 283L337 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M420 282L421 283L420 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M529 282L530 283L529 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M564 282L565 283L564 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M644 282L645 283L644 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M717 282L718 283L717 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M718 282L719 283L718 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M750 282L751 283L750 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M860 282L861 283L860 282M942 282L943 283L942 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M55 283L56 284L55 283M117 283L118 284L117 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M221 283L222 284L221 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M222 283L223 284L222 283M283 283L284 284L283 283M337 283L338 284L337 283M417 283L418 284L417 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M418 283L419 284L418 283M481 283L482 284L481 283M527 283L521 290L527 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M528 283L529 284L528 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M563 283L564 284L563 283M643 283L644 284L643 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M717 283L718 284L717 283M749.333 283.667L749.667 284.333L749.333 283.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M750 283L751 284L750 283M781 283L782 284L781 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M859 283L860 284L859 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M939 283L940 284L939 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M940 283L941 284L940 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M56 284L57 285L56 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M119 284L120 285L119 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M219 284L220 285L219 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M220 284L221 285L220 284M282 284L283 285L282 284M415 284L416 285L415 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M416 284L417 285L416 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M447.333 284.667L447.667 285.333L447.333 284.667M481 284L482 285L481 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M716 284L717 285L716 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M781 284L782 285L781 284M859 284L860 285L859 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M57 285L58 286L57 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M121 285L122 286L121 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M217 285L218 286L217 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M218 285L219 286L218 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M336 285L337 286L336 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M412 285L413 286L412 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M413 285L414 286L413 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M414 285L415 286L414 285M482 285L484 289L485 289L482 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M562 285L563 286L562 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M642 285L643 286L642 285M715 285L716 286L715 285M749 285L750 286L749 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M859 285L860 286L859 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M937 285L938 286L937 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M58 286L59 287L58 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M123 286L124 287L123 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M124 286L125 287L124 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M215 286L216 287L215 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M216 286L217 287L216 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M281 286L282 287L281 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M336 286L337 287L336 286M409 286L410 287L409 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M410 286L411 287L410 286M447.333 286.667L447.667 287.333L447.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M482 286L483 287L482 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M525 286L526 287L525 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M641 286L640 288L641 286M714 286L715 287L714 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M715 286L716 287L715 286M748.333 286.667L748.667 287.333L748.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M749 286L750 287L749 286M780 286L781 287L780 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M858 286L859 287L858 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M937 286L938 287L937 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M58 287L59 288L58 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M125 287L126 288L125 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M126 287L127 288L126 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M213 287L214 288L213 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M280 287L281 288L280 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M405 287L406 288L405 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M406 287L407 288L406 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M407 287L408 288L407 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M524 287L525 288L524 287M561 287L562 288L561 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M641 287L642 288L641 287M714 287L715 288L714 287M780.333 287.667L780.667 288.333L780.333 287.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M858 287L859 288L858 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M59 288L60 289L59 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M128 288L129 289L128 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M210 288L211 289L210 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M211 288L212 289L211 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M279 288L280 289L279 288M335 288L336 289L335 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M400.667 288.333L401.333 288.667L400.667 288.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M402 288L403 289L402 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M403 288L404 289L403 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M523 288L524 289L523 288M560 288L561 289L560 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M640 288L641 289L640 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M713 288L714 289L713 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M748 288L749 289L748 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M857 288L858 289L857 288M890 290L904 289C900.234 287.42 892.848 286.741 890 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M904 288L905 289L904 288M938 288L939 289L938 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M60 289L61 290L60 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M130 289L131 290L130 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M131 289L132 290L131 289M207 289L208 290L207 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M208 289L209 290L208 289M278 289L279 290L278 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M389 289L389 290L394 290L389 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M394 289L394 290L397 290L394 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M397 289L398 290L397 289M485 289L490 293L485 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M522 289L523 290L522 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M560 289L561 290L560 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M639 289L640 290L639 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M712 289L713 290L712 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M713 289L714 290L713 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M779 289L780 290L779 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M857 289L858 290L857 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M889 289L890 290L889 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M904 289L905 290L904 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M939 289L940 290L939 289M61 290L62 291L61 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M133 290L134 291L133 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M134 290L135 291L134 290M204 290L205 291L204 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M205 290L206 291L205 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M206 290L207 291L206 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M277 290L278 291L277 290M334 290L335 291L334 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M366 290L367 291L366 290M448 290L449 291L448 290M485 290L486 291L485 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M520 290L521 291L520 290M559 290L560 291L559 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M638 290L639 291L638 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M712 290L711 292L713 292L712 290M747 290L748 291L747 290M779 290L780 291L779 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M857 290L858 291L857 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M889 290L890 291L889 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M904 290L905 291L904 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M939 290L940 291L939 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M62 291L63 292L62 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M136 291L137 292L136 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M137 291L138 292L137 291M201 291L202 292L201 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M202 291L203 292L202 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M203 291L204 292L203 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M276 291L277 292L276 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M334 291L335 292L334 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M366 291L367 292L366 291M448 291L449 292L448 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M518 291L519 292L518 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M558 291L559 292L558 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M638 291L639 292L638 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M747 291L748 292L747 291M778 291L779 292L778 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M856 291L857 292L856 291M889 291L890 292L889 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M905 291L906 292L905 291M939 291L940 292L939 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M63 292L64 293L63 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M139 292L140 293L139 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M140 292L141 293L140 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M141 292L142 293L141 292M198 292L199 293L198 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M199 292L200 293L199 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M275 292L276 293L275 292M448 292L449 293L448 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M488 292L489 293L488 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M515.667 292.333L516.333 292.667L515.667 292.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M517 292L518 293L517 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M558 292L559 293L558 292M637 292L638 293L637 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M710 292L711 293L710 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M746 292L747 293L746 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M778 292L779 293L778 292M856 292L857 293L856 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M888 292L889 293L888 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M905 292L906 293L905 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M940 292L941 293L940 292M64 293L65 294L64 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M142.667 293.333L143.333 293.667L142.667 293.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M144 293L145 294L144 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M145 293L146 294L145 293M193.667 293.333L194.333 293.667L193.667 293.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M195.667 293.333L196.333 293.667L195.667 293.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M274 293L275 294L274 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M333 293L334 294L333 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M365 293L366 294L365 293M449 293L450 294L449 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M490 293L491 294L490 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M513 293L514 294L513 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M514 293L515 294L514 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M515 293L516 294L515 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M557.333 293.667L557.667 294.333L557.333 293.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M636 293L637 294L636 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M709 293L710 294L709 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M746 293L747 294L746 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M778 293L778 295L780 295L778 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M856 293L857 294L856 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M888 293L889 294L888 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M940 293L941 294L940 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M65 294L66 295L65 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M66 294L67 295L66 294M147.667 294.333L148.333 294.667L147.667 294.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M149 294L150 295L149 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M150 294L151 295L150 294M188.667 294.333L189.333 294.667L188.667 294.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M190 294L191 295L190 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M191 294L192 295L191 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M273 294L274 295L273 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M333 294L334 295L333 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M365 294L366 295L365 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M449 294L450 295L449 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M492 294L493 295L492 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M493 294L494 295L493 294M511 294L512 295L511 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M512 294L513 295L512 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M556 294L557 295L556 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M635 294L636 295L635 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M636 294L637 295L636 294M709 294L710 295L709 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M746 294L747 295L746 294M777 294L793 296L838 296L838 295C818.774 295 795.709 298.454 777 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M855 294L856 295L855 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M887 294L888 295L887 294M906 294L907 295L906 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M941.333 294.667L941.667 295.333L941.333 294.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M152 295L152 296L155 296L152 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M155.667 295.333L156.333 295.667L155.667 295.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M157.667 295.333L158.333 295.667L157.667 295.333M181.667 295.333L182.333 295.667L181.667 295.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M183 295L184 296L183 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M184.667 295.333L185.333 295.667L184.667 295.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M272 295L273 296L272 295M449 295L450 296L449 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M495.667 295.333L496.333 295.667L495.667 295.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M497 295L498 296L497 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M498.667 295.333L499.333 295.667L498.667 295.333M506 295L507 296L506 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M507 295L508 296L507 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M508.667 295.333L509.333 295.667L508.667 295.333M555 295L554 297L555 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M635 295L636 296L635 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M708 295L709 296L708 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M745 295L746 296L745 295M838 295L839 296L838 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M855 295L856 296L855 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M887 295L888 296L887 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M906 295L907 296L906 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M68 296L69 297L68 296M162 296L162 297L177 297L162 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M271 296L272 297L271 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M332 296L333 297L332 296M364 296L365 297L364 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M450 296L451 297L450 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M555 296L556 297L555 296M634 296L635 297L634 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M707 296L708 297L707 296M745 296L746 297L745 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M887.333 296.667L887.667 297.333L887.333 296.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M941 296L942 297L941 296M69 297L70 298L69 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M270 297L271 298L270 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M332 297L333 298L332 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M364 297L365 298L364 297M450 297L451 298L450 297M554 297L555 298L554 297M587 297L587 304L588 304L587 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M633 297L632 299L633 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M707 297L708 298L707 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M837 297L838 298L837 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M854 297L855 298L854 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M886 297L887 298L886 297M907 297L908 298L907 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M942 297L943 298L942 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M70 298L71 299L70 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M268 298L269 299L268 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M331 298L332 299L331 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M363 298L364 299L363 298M451 298L452 299L451 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M553 298L554 299L553 298M633 298L634 299L633 298M706 298L707 299L706 298M744 298L745 299L744 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M837 298L838 299L837 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M854 298L855 299L854 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M886 298L887 299L886 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M907 298L908 299L907 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M942 298L943 299L942 298M71 299L72 300L71 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M267 299L268 300L267 299M331 299L332 300L331 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M363 299L364 300L363 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M451 299L452 300L451 299M552 299L553 300L552 299M632 299L633 300L632 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M705 299L706 300L705 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M744 299L745 300L744 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M837 299L838 300L837 299M853 299L854 300L853 299M886 299L887 300L886 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M908 299L909 300L908 299M942 299L943 300L942 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M943 299L945 302L943 299M72 300L73 301L72 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M266 300L267 301L266 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M363 300L364 301L363 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M452 300L453 301L452 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M551 300L552 301L551 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M631 300L632 301L631 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M704 300L705 301L704 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M743 300L744 301L743 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M836 300L837 301L836 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M853 300L854 301L853 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M885 300L886 301L885 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M908 300L909 301L908 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M73 301L74 302L73 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M74 301L75 302L74 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M265 301L266 302L265 301M330 301L331 302L330 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M362 301L363 302L362 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M452 301L453 302L452 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M550 301L551 302L550 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M630 301L631 302L630 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M631 301L632 302L631 301M704 301L705 302L704 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M743 301L744 302L743 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M836 301L837 302L836 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M853 301L854 302L853 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M885 301L886 302L885 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M943 301L944 302L943 301M75 302L76 303L75 302M263 302L264 303L263 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M264 302L265 303L264 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M330 302L331 303L330 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M362 302L363 303L362 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M453 302L454 303L453 302M549 302L550 303L549 302M703 302L704 303L703 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M743 302L744 303L743 302M835 302L836 303L835 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M852 302L853 303L852 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M909 302L910 303L909 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M76 303L77 304L76 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M262 303L263 304L262 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M548 303L549 304L548 303M629 303L630 304L629 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M702 303L703 304L702 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M703 303L704 304L703 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M835 303L836 304L835 303M852 303L853 304L852 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M884 303L885 304L884 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M909 303L910 304L909 303M944 303L945 304L944 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M77 304L78 305L77 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M261 304L262 305L261 304M329 304L330 305L329 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M361 304L362 305L361 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M454 304L455 305L454 304M547 304L548 305L547 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M587 304L587 312L588 312L587 304M628 304L629 305L628 304M742 304L743 305L742 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M835 304L836 305L835 304M884 304L885 305L884 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M944 304L945 305L944 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M945.333 304.667L945.667 305.333L945.333 304.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M79 305L80 306L79 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M260 305L261 306L260 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M329 305L330 306L329 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M361 305L362 306L361 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M455 305L456 306L455 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M545 305L544 307L545 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M546 305L547 306L546 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M627 305L628 306L627 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M628 305L629 306L628 305M701 305L699 309L701 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M742 305L743 306L742 305M834 305L835 306L834 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M851 305L852 306L851 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M883 305L884 306L883 305M910 305L911 306L910 305M80 306L81 307L80 306M258 306L259 307L258 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M328 306L329 307L328 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M360 306L361 307L360 306M456 306L457 307L456 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M545 306L546 307L545 306M627 306L624 311L627 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M700 306L701 307L700 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M741 306L742 307L741 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M834 306L835 307L834 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M851 306L852 307L851 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M883 306L884 307L883 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M910 306L911 307L910 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M945 306L946 307L945 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M81 307L82 308L81 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M257 307L258 308L257 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M328 307L329 308L328 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M360 307L361 308L360 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M457 307L460 310L457 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M543 307L544 308L543 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M544 307L545 308L544 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M626 307L627 308L626 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M699 307L700 308L699 307M741 307L742 308L741 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M834 307L835 308L834 307M850 307L851 308L850 307M883 307L884 308L883 307M946 307L947 308L946 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M83 308L84 309L83 308M255 308L256 309L255 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M457 308L458 309L457 308M542 308L543 309L542 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M625 308L626 309L625 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M740 308L741 309L740 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M833 308L834 309L833 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M850 308L851 309L850 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M882 308L883 309L882 308M911 308L912 309L911 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M946 308L947 309L946 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M84 309L85 310L84 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M254 309L255 310L254 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M327 309L328 310L327 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M359 309L360 310L359 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M458 309L459 310L458 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M540 309L541 310L540 309M624 309L625 310L624 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M698 309L699 310L698 309M740 309L741 310L740 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M833 309L834 310L833 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M850 309L851 310L850 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M882 309L883 310L882 309M911 309L912 310L911 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M946 309L947 310L946 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M947.333 309.667L947.667 310.333L947.333 309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M86 310L87 311L86 310M252 310L253 311L252 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M253 310L254 311L253 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M327 310L328 311L327 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M359 310L360 311L359 310M539 310L540 311L539 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M697 310L698 311L697 310M740 310L741 311L740 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M849 310L850 311L849 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M912 310L913 311L912 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M87 311L88 312L87 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M251 311L252 312L251 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M461 311L462 312L461 311M537 311L538 312L537 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M538 311L539 312L538 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M623 311L624 312L623 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M697 311L696 313L698 313L697 311M739 311L740 312L739 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M832 311L833 312L832 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M849 311L850 312L849 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M881 311L882 312L881 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M912 311L913 312L912 311M947 311L948 312L947 311M89 312L90 313L89 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M249 312L250 313L249 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M250 312L251 313L250 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M326 312L327 313L326 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M358 312L359 313L358 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M462 312L463 313L462 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M536 312L537 313L536 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M587 312L587 322L588 322L587 312M622 312L623 313L622 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M623 312L624 313L623 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M739 312L740 313L739 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M832.333 312.667L832.667 313.333L832.333 312.667M848.333 312.667L848.667 313.333L848.333 312.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M849 312L850 313L849 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M881.333 312.667L881.667 313.333L881.333 312.667M912.333 312.667L912.667 313.333L912.333 312.667M948 312L949 316L950 316L948 312M90 313L91 314L90 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M91 313L92 314L91 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M248 313L249 314L248 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M326 313L327 314L326 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M358 313L359 314L358 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M463 313L464 314L463 313M534 313L535 314L534 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M622 313L623 314L622 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M660 313C660.012 328.003 677.469 323 689 323L689 322L661 322L660 313M695 313L696 314L695 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M739 313L740 314L739 313M831 313L832 314L831 313M880 313L881 314L880 313M913 313L914 314L913 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M92 314L93 315L92 314M246 314L247 315L246 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M325 314L326 315L325 314M464 314L465 315L464 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M465 314L466 315L465 314M532 314L533 315L532 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M533 314L534 315L533 314M621 314L619 318L621 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M694 314L695 315L694 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M695 314L696 315L695 314M738 314L739 315L738 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M831 314L832 315L831 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M848 314L849 315L848 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M880 314L881 315L880 314M913 314L914 315L913 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M948 314L949 315L948 314M94 315L95 316L94 315M244 315L245 316L244 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M245 315L246 316L245 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M325 315L326 316L325 315M357 315L358 316L357 315M466 315L467 316L466 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M530 315L531 316L530 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M531 315L532 316L531 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M620 315L621 316L620 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M694 315L695 316L694 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M738 315L739 316L738 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M831 315L832 316L831 315M880 315L881 316L880 315M913 315L914 316L913 315M95 316L96 317L95 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M96 316L97 317L96 316M242 316L243 317L242 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M243 316L244 317L243 316M357 316L358 317L357 316M467 316L468 317L467 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M468 316L469 317L468 316M528 316L529 317L528 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M529 316L530 317L529 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M619 316L620 317L619 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M693 316L694 317L693 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M830 316L831 317L830 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M847 316L848 317L847 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M879 316L880 317L879 316M914 316L915 317L914 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M949 316L950 317L949 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M97 317L98 318L97 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M98 317L99 318L98 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M241 317L242 318L241 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M324 317L325 318L324 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M356 317L357 318L356 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M469 317L470 318L469 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M470 317L471 318L470 317M526 317L527 318L526 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M527 317L528 318L527 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M692 317L693 318L692 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M693 317L694 318L693 317M737 317L738 318L737 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M830 317L831 318L830 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M846.333 317.667L846.667 318.333L846.333 317.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M847 317L848 318L847 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M879 317L880 318L879 317M914 317L915 318L914 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M949 317L950 318L949 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M950.333 317.667L950.667 318.333L950.333 317.667M99 318L100 319L99 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M100 318L101 319L100 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M239 318L240 319L239 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M324 318L325 319L324 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M356 318L357 319L356 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M471 318L472 319L471 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M472 318L473 319L472 318M523 318L524 319L523 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M524 318L525 319L524 318M618 318L619 319L618 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M737 318L738 319L737 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M879 318L880 319L879 318M101 319L102 320L101 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M102 319L103 320L102 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M237 319L238 320L237 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M473 319L474 320L473 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M474 319L475 320L474 319M521 319L522 320L521 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M522 319L523 320L522 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M617 319L616 321L617 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M618 319L619 320L618 319M691.333 319.667L691.667 320.333L691.333 319.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M829 319L830 320L829 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M846 319L847 320L846 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M878 319L879 320L878 319M915 319L916 320L915 319M950 319L951 320L950 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M103 320L104 321L103 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M234 320L235 321L234 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M235 320L236 321L235 320M323.333 320.667L323.667 321.333L323.333 320.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M355 320L324 321L324 322L356 321L355 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M476 320L477 321L476 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M477 320L478 321L477 320M517 320L518 321L517 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M518 320L519 321L518 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M519 320L520 321L519 320M617 320L618 321L617 320M659 320L660 321L659 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M690 320L691 321L690 320M736.333 320.667L736.667 321.333L736.333 320.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M829 320L830 321L829 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M846 320C850.695 325.372 870.937 322 878 322L878 321L846 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M878.667 320.333L879.333 320.667L878.667 320.333M915 320L916 321L915 320M951.333 320.667L951.667 321.333L951.333 320.667M105 321L106 322L105 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M106 321L107 322L106 321M232 321L233 322L232 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M233 321L234 322L233 321M355 321L356 322L355 321M478.667 321.333L479.333 321.667L478.667 321.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M480 321L481 322L480 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M481 321L482 322L481 321M513.667 321.333L514.333 321.667L513.667 321.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M515.667 321.333L516.333 321.667L515.667 321.333M616 321L617 322L616 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M689 321L690 322L689 321M737 321L737 322L829 322L801 321L737 321M916 321L916 322L951 322L916 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M107 322L108 323L107 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M108 322L109 323L108 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M230 322L231 323L230 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M231 322L232 323L231 322M483 322L484 323L483 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M484 322L485 323L484 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M485.667 322.333L486.333 322.667L485.667 322.333M508.667 322.333L509.333 322.667L508.667 322.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M510 322L511 323L510 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M511 322L512 323L511 322M587 322L588 323L587 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M588 322L588 323L615 323L588 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M615 322L616 323L615 322M660 322L661 323L660 322M689 322L690 323L689 322M110 323L111 324L110 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M111 323L112 324L111 323M228 323L229 324L228 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M229 323L230 324L229 323M488 323L488 324L491 324L488 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M491.667 323.333L492.333 323.667L491.667 323.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M493 323L493 324L501 324L493 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M501 323L501 324L504 324L501 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M504.667 323.333L505.333 323.667L504.667 323.333M688 323L689 324L688 323M112 324L113 325L112 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M113 324L114 325L113 324M225 324L226 325L225 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M226 324L227 325L226 324M115 325L116 326L115 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M116 325L117 326L116 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M223 325L224 326L223 325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M224 325L225 326L224 325M117 326L118 327L117 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M118 326L119 327L118 326M220 326L221 327L220 326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M221 326L222 327L221 326M120 327L121 328L120 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M121 327L122 328L121 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M217 327L218 328L217 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M218 327L219 328L218 327M123 328L124 329L123 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M124 328L125 329L124 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M125 328L126 329L125 328M214 328L215 329L214 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M215 328L216 329L215 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M126.667 329.333L127.333 329.667L126.667 329.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M128 329L129 330L128 329M210 329L211 330L210 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M211 329L212 330L211 329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M212 329L213 330L212 329M130 330L131 331L130 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M131 330L132 331L131 330M206.667 330.333L207.333 330.667L206.667 330.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M208 330L209 331L208 330M134 331L135 332L134 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M135 331L136 332L135 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M136 331L137 332L136 331M203 331L204 332L203 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M204 331L205 332L204 331M139 332L140 333L139 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M140 332L141 333L140 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M141 332L142 333L141 332M197 332L198 333L197 332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M198.667 332.333L199.333 332.667L198.667 332.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M200 332L201 333L200 332M144 333L145 334L144 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M145 333L146 334L145 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M146.667 333.333L147.333 333.667L146.667 333.333M191.667 333.333L192.333 333.667L191.667 333.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M193 333L194 334L193 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M194 333L195 334L194 333M150.667 334.333L151.333 334.667L150.667 334.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M152.667 334.333L153.333 334.667L152.667 334.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969bb9",
      stroke: "none"
    },
    d: "M154 334L154 335L157 335L154 334M181 334L181 335L184 335L181 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M184 334L184 335L187 335L184 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M187.667 334.333L188.333 334.667L187.667 334.333M162 335L162 336L168 336L162 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#676c8e",
      stroke: "none"
    },
    d: "M168.667 335.333L169.333 335.667L168.667 335.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3b426c",
      stroke: "none"
    },
    d: "M170 335L170 336L178 336L170 335z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpLogoDark);
export default __webpack_public_path__ + "static/media/SP-logo-dark.df2a16d19061f37763a086275a4b8eec.svg";
export { ForwardRef as ReactComponent };